import React, { Component, useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography, Grid, TextField, Button, CircularProgress, FormControl, InputLabel, Select, MenuItem, OutlinedInput, Box, Chip, Tooltip, DialogActions, RadioGroup, FormControlLabel, Radio, Autocomplete } from '@mui/material';
import { IoMdCloseCircleOutline } from "react-icons/io";
import { DataTable, DatePicker, FontIcon, TableBody, TableColumn, TableHeader, TimePicker } from 'react-md';
import Toggle from 'react-toggle';
import TextEditor from '../../../component/TextEditor';
import { MdDragIndicator } from "react-icons/md";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { BsInfoCircleFill } from "react-icons/bs";
import { PiCaretUpBold, PiCaretDownBold } from "react-icons/pi";
import { IoIosCloseCircle } from "react-icons/io";
import ApiRequestService from '../../../component/ApiRequestService';
import { NotificationManager } from 'react-notifications';
import moment from 'moment';
import { DEFAULT_AT_FIRST, DEFAULT_AT_LAST, DEFAULT_LOCKOUT, DEFAULT_MASTERY_COUNT, DEFAULT_MAXIMUM_ATTEMPT, DEFAULT_NOCQC, DEFAULT_RADNOM_SUBCATEGORY_ORDER, DEFAULT_RANDOMIZE_CATEGORIES, DEFAULT_REQUIRED, MAX_QUESTION_COUNT_FOR_ONE_PAGE_TEST } from '../Constants';
import CategoryOptionsModal from './CategoryOptionsModal';
import { AppProperties } from '../../../common/function';
import HelpText from '../../../lib/help-text';
import EditWindow from '../../EditWindow';
import CollapsableColumn from '../../../component/CollapsableColumn';
import { TableRow as TableRowReact } from 'react-md';
import editIcon from '../../../images/png/edit.png';
import crossIcon from '../../../images/png/crossIcon.png';
import SubjectTopicCategorySelect from '../SubjectTopicCategorySelect';
import { IoLink } from 'react-icons/io5';
import { GoTrash } from "react-icons/go";
import SectionSubsectionDialog from './SectionSubsectionDialog';
import { UnsyncedCategoriesDialog, READ_ONLY_HINT } from '../../AssignmentMatrixLibrary/LibrarySync';
// import SFSectionSubsectionDialog from './SFSectionSubsectionDialog';
import SFSectionAndSubsectionSelectField from './SFSectionAndSubsectionSelectField';
import { BeatLoader } from 'react-spinners';

import { DEFAULT_END_SPLASH_SCREEN_TEXT } from '../Constants';
import SFDatePicker from '../../../component/SFDatePicker';

class AssignmentDetailModal extends Component {

    helpTextModel = new HelpText();

    appProperties = AppProperties();
    
    queryParams = new URLSearchParams(window.location.search);

    constructor(props) {
        super(props);
        this.state = {
            showCategoryOptions: false,
            assignment: this.props.assignment,
            saveLoading: false,
            savePublishLoading: false,

            // Set when the sync coverage gate refuses the save, which is the
            // whole list of question bank rows the other universities lack.
            // null keeps the dialog closed - it opens on an array, empty or not.
            unsyncedCategories: null,

            // For date
            startDate: "",
            endDate: "",

            // For splash screen
            splashTextEditorObj: null,
            splashScreenText: "",
            altSplashScreenTextVisible: false,
            imgTagCount: 0,
            altSplashScreenText: "",
            endSplashScreenText: DEFAULT_END_SPLASH_SCREEN_TEXT,
            endSplashTextEditorObj: null,
            altSplashEndScreenTextVisible: false,
            imgTagCountInEndSplashScreen: 0,
            altEndSplashScreenText: "",

            // Section
            sections: [],
            subsections: [],
            hasSubSections: false,
            enableSubSection: false,
            selectedSectionIDArr: [],
            selectedSubsectionsArr: [],
            selectedSectionAndSubsectionList: [],

            // removed subcategories from table
            removedSucbategories: [],


            // Cat Subcategory table
            subcategories: [],
            categories: [],

            // Freechoice 
            freeChoiceCount: 0,

            // Extend
            showEditDueDates: false,
            showSectionsAndSubsectionsDialog: false,

            isQuizAttended: false,

            loadingSections: false,

            resetPreviewLoading: false,
            splashScreenAltText:[],
            endSplashScreenAltText:[],

            isCurrentSemester: this.queryParams && this.queryParams.get("is_current_semester") ? this.queryParams.get("is_current_semester") === "true" : true
        };
    }

    componentDidMount() {
        // readOnly shows a tutorial received from another university: the same
        // Save buttons are withheld, and the fields below are locked as well.
        if (this.props.disableButtons || this.props.readOnly) {
            this.setState({
                isCurrentSemester: false,
            })
        }
        this.updateOnMountState();
        if (this.props.course_id) {
            this.getCourseSections();
        }

        console.debug("this.props.assignment>>??", this.props.assignment)
        if (this.props.assignment === null) {
            let defaultAssignmentData = {
                quiz_id: null,
                quiz_type:  0,
                quiz_name: "",
                allow_practice: true, // by default all quizzes are practicable
                course_id: this.props.course_id,
                randomize_categories: DEFAULT_RANDOMIZE_CATEGORIES,
                mastery_condition: DEFAULT_MASTERY_COUNT,
                maximum_attempted: DEFAULT_MAXIMUM_ATTEMPT,
                lockoutN: DEFAULT_LOCKOUT,
                NoCQC: DEFAULT_NOCQC,
                enable_subsection: false,
                sections_list: [],
                show_calculator: 1,
                status: 0, // by default unpublished
            }
            if (this.props.isAssessment) {
                defaultAssignmentData.quiz_type = 1
                defaultAssignmentData.is_anonymous = true
                defaultAssignmentData.is_assessment = true
                defaultAssignmentData.is_nongraded = 1
                defaultAssignmentData.randomize_categories = 1
            }
            this.setState({
                assignment: defaultAssignmentData
            })
        }
    }

    handleDeleteUserDataForQuiz = (showSuccessNotification) => {
        this.setState({
            resetPreviewLoading: true
        });
        ApiRequestService({
            method: 'post',
            url: '/deleteUserQuizAttendedData',
            data: {
                quiz_id: this.state.assignment?.quiz_id,
            }
        }).then(res => {
            if (res != null &&
                res.data != null &&
                res.data.message !== null &&
                res.data.message !== "") {
                NotificationManager.error('Error while deleting the user record', 'ERROR', 3000);
            } else {
                if (showSuccessNotification) {
                    NotificationManager.success("User record deleted successfully!", 'Success', 3000);
                }
                this.setState({ isQuizAttended: false })
            }
        }).catch(error => {
            NotificationManager.error('Error while deleting the user record', 'ERROR', 3000);
            console.error('Error while Deleting the User Data ', error);
        }).finally(() => {
            this.setState({
                resetPreviewLoading: false
            });
        });
    }

    getCourseSections = () => {
        let payload = {
            course_id: this.props.course_id,
            semesterID: this.props.semesterID,
        }

        const queryParams = new URLSearchParams(window.location.search);
        if (queryParams && queryParams.get("semester_id")) {
            payload.semesterID = parseInt(queryParams.get("semester_id"), 10)
        }

        this.setState({
            loadingSections: true,
        })
        ApiRequestService({
            method: 'post',
            url: '/getAllSections',
            data: payload
        }).then(async (res) => {
            if (res && res.data && res.data.data) {
                let sectionsArr = res.data.data.section_names;
                let subsectionsArr = [];
                let hasSubSections = false;

                let index = sectionsArr?.findIndex(sec => sec.enable_subsection);
                if (index >= 0) hasSubSections = true;

                let selectedSectionAndSubsectionList = [];

                // get all subections for sections has enabled
                for (let i = 0; i < sectionsArr.length; i++) {
                    const section = sectionsArr[i];
                    if (section.enable_subsection) {
                        const subsections = await this.getSubsections({
                            course_id: this.props.course_id,
                            section_id: section.section_id
                        })
                        subsectionsArr.push(...subsections);

                        // check if this subsection is present in assignment
                        if (this.state.assignment && this.state.assignment.sections_list && this.state.assignment.sections_list.length) {
                            // Find ALL entries for this section (there may be multiple with different subsections)
                            let matchingSections = this.state.assignment.sections_list.filter(sec => sec.id === section.section_id);

                            if (matchingSections.length > 0) {
                                let tempSectionID = matchingSections[0].section_id || matchingSections[0].id;
                                let tempSectionName = matchingSections[0].section_name || matchingSections[0].label;

                                // Collect all subsection IDs for this section
                                let subsectionIDs = matchingSections.map(sec => sec.subsection_id);

                                // Filter subsections that match any of the subsection IDs
                                let matchingSubsections = subsections.filter(subSec =>
                                    subSec.section_id === tempSectionID && subsectionIDs.includes(subSec.subsection_id)
                                );

                                selectedSectionAndSubsectionList.push({
                                    section_id: tempSectionID,
                                    section_name: tempSectionName,
                                    subsectionList: matchingSubsections,
                                    subsection: matchingSubsections.map(subSec => subSec.subsection_name)
                                })
                            }
                        }
                    }
                }

                //console.debug("selectedSectionAndSubsectionList>>", selectedSectionAndSubsectionList)

                this.setState({
                    loadingSections: false,
                    sections: sectionsArr,
                    subsections: subsectionsArr,
                    selectedSectionAndSubsectionList: selectedSectionAndSubsectionList,
                    hasSubSections,
                })
            } else {
                this.setState({
                    loadingSections: false,
                })
            }
        }).catch(error => {
            console.debug("error", error);
            this.setState({
                loadingSections: false,
            })
        })
    }

    getSubsections = async (payload) => {
        const res = await ApiRequestService({
            method: 'post',
            url: '/getAllSubSections',
            data: payload
        })
        if (res.data && res.data.data && res.data.data.subsection_names != null && res.data.data.subsection_names.length > 0) {
            return res.data.data.subsection_names;
        } else {
            return [];
        }
    }


    updateOnMountState = () => {
        let assignment = this.props.assignment;
        if (assignment) {
            let obj = TextEditor.createValueFromString(
                assignment.splash_screen,
                'html'
            )
            let endSplashScreenTextObj = "";
            let endSplashScreenText = "";
            if (assignment.end_splash_screen != "") {
                endSplashScreenTextObj = TextEditor.createValueFromString(
                    assignment.end_splash_screen,
                    'html'
                )
                endSplashScreenText = assignment.end_splash_screen;
            } else {
                endSplashScreenTextObj = TextEditor.createValueFromString(
                    this.state.endSplashScreenText,
                    'html'
                )
                endSplashScreenText = this.state.endSplashScreenText;
            }


            //console.debug("assignment>>??", assignment);

            let subcategories = assignment.quiz_subcat_info;
            if (subcategories) {
                subcategories.sort((subcat1, subcat2) => {
                    return subcat1.order - subcat2.order;
                })
            }

            let selectedSectionIDArr = assignment.sections_list && assignment.sections_list.length ? assignment.sections_list.map(sec => sec.id) : [];

            let categoryMasteryCountJSON = assignment?.category_mastery_count ? JSON.parse(assignment.category_mastery_count) : {};
            let categoryNocqcJSON = assignment?.category_nocqc ? JSON.parse(assignment.category_nocqc) : {};
            let randomSubcategoryOrderJSON = assignment?.random_subcategory_order ? JSON.parse(assignment.random_subcategory_order) : {};
            let categoryIsRequiredJSON = assignment?.category_is_required ? JSON.parse(assignment.category_is_required) : {};
            let categoryPositionJSON = assignment?.category_position ? JSON.parse(assignment.category_position) : {};
            let categoryNoOfQuestionsJSON = assignment?.category_number_of_questions ? JSON.parse(assignment.category_number_of_questions) : {};

            let categories = [];
            let seenCategoryKeys = new Set();
            if (assignment.quiz_details) {
                assignment.quiz_details.forEach(category => {
                    const catKey = `${category.subject_id}_${category.topic_id}_${category.category_id}`;
                    let totalCategoryQuestionCount = assignment.quiz_details
                        .filter(q =>
                            q.subject_id === category.subject_id &&
                            q.topic_id === category.topic_id &&
                            q.category_id === category.category_id
                        )
                        .reduce((sum, item) => sum + (item.question_count || 0), 0);
                    if (!seenCategoryKeys.has(catKey)) {
                        let obj = assignment?.quiz_subcat_info?.find(subcat => {
                            let key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;
                            return catKey == key;
                        })
                        let cat = {
                            ...category,
                            masteryCount: categoryMasteryCountJSON[catKey] ? categoryMasteryCountJSON[catKey] : DEFAULT_MASTERY_COUNT,
                            nocqc: categoryNocqcJSON[catKey] ? categoryNocqcJSON[catKey] : DEFAULT_NOCQC,
                            randomSubcategoryOrder: randomSubcategoryOrderJSON[catKey] ? randomSubcategoryOrderJSON[catKey] : DEFAULT_RADNOM_SUBCATEGORY_ORDER,
                            required: categoryIsRequiredJSON[catKey] ? categoryIsRequiredJSON[catKey] : DEFAULT_REQUIRED,
                            atFirst: categoryPositionJSON[catKey] ? categoryPositionJSON[catKey].category_at_begining : DEFAULT_AT_FIRST,
                            atLast: categoryPositionJSON[catKey] ? categoryPositionJSON[catKey].category_at_last : DEFAULT_AT_LAST,
                            noOfQuestion: categoryNoOfQuestionsJSON[catKey] ? categoryNoOfQuestionsJSON[catKey] : 0,
                            subject_name: obj?.subject_name ? obj?.subject_name : "",
                            topic_name: obj?.topic_name ? obj?.topic_name : "",
                            question_count: totalCategoryQuestionCount,
                        }
                        categories.push(cat);
                    }
                    seenCategoryKeys.add(catKey);
                })
            }

            console.debug("subcategories>>??", subcategories)
            console.debug("categories>>??", categories, assignment.quiz_details)

            let altEndSplashScreenTexttemp = assignment.alt_end_splash_screen; // "test1;test2;test2;rwar3"

            if (altEndSplashScreenTexttemp) {
                const parts = altEndSplashScreenTexttemp.split(';').filter(Boolean);
                const endSplashScreenAltTexttemp = [];

                for (let i = 0; i < parts.length; i += 2) {
                    endSplashScreenAltTexttemp.push({
                        title: parts[i] || '',
                        alt: parts[i + 1] || ''
                    });
                }
                this.setState({ endSplashScreenAltText:endSplashScreenAltTexttemp });
            }
            if (assignment.alt_splash_screen) {
                const parts = assignment.alt_splash_screen.split(';').filter(Boolean);
                const splashScreenAltTexttemp = [];
                for (let i = 0; i < parts.length; i += 2) {
                    splashScreenAltTexttemp.push({
                        title: parts[i] || '',
                        alt: parts[i + 1] || ''
                    });
                }
                this.setState({ splashScreenAltText:splashScreenAltTexttemp });
            }
            this.setState({
                splashTextEditorObj: obj,
                splashScreenText: assignment.splash_screen,
                endSplashScreenText: endSplashScreenText,
                endSplashTextEditorObj: endSplashScreenTextObj,
                altSplashScreenText: assignment.alt_splash_screen,
                enableSubSection: assignment.enable_subsection,
                hasSubSections: assignment.show_enable_subsection,
                subcategories: subcategories,
                selectedSectionIDArr: selectedSectionIDArr,
                categories: categories,
                freeChoiceCount: assignment.free_choice_count,
                isQuizAttended: assignment?.isQuizAttended,
            })

            var startDateAndTime = assignment.start_date + ' ' + assignment.start_time;
            var endDateAndTime = assignment.end_date + ' ' + assignment.end_time;
            var resStartDate = '';
            var resEndDate = '';
            if (
                assignment.start_date !== null &&
                assignment.start_date !== ''
            ) {
                resStartDate = moment(startDateAndTime, 'DD-MM-YYYY HH-mm');
            }
            if (
                assignment.end_date !== null &&
                assignment.end_date !== ''
            ) {
                resEndDate = moment(endDateAndTime, 'DD-MM-YYYY HH-mm');
            }
            this.setState({
                startDate: resStartDate,
                endDate: resEndDate,
            })
        } else {
            let endSplashScreenTextObj = "";
            let endSplashScreenText = "";
            endSplashScreenTextObj = TextEditor.createValueFromString(
                this.state.endSplashScreenText,
                'html'
            )
            endSplashScreenText = this.state.endSplashScreenText;
            this.setState({
                endSplashScreenText: endSplashScreenText,
                endSplashTextEditorObj: endSplashScreenTextObj,

                splashScreenText: "",
                splashTextEditorObj: TextEditor.createValueFromString(
                    "",
                    'html'
                ),
            })
        }

    }

    onDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(this.state.subcategories);
        const [reordered] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reordered);

        const reorderedWithOrder = items.map((item, idx) => ({
            ...item,
            order: idx + 1
        }));

        let updatedSubcategories = this.markInvalidSubcategoryOrder(reorderedWithOrder);
        this.setState({
            subcategories: updatedSubcategories,
        });
    };

    /* handleSaveLibraryAssignment = () => {

        let tempAltSplashScreenText = this.state.altSplashScreenText;
        // Validate splash screen images
        if (this.state.imgTagCount >= 1) {
            let tempaltSplashScreen = tempAltSplashScreenText
            tempaltSplashScreen = tempaltSplashScreen.replace(/\n/ig, '')
            tempaltSplashScreen = tempaltSplashScreen.replace(/ /g, '')
            let attrTextArr = tempaltSplashScreen.split(';')
            attrTextArr = attrTextArr.filter(function (el) {
                return el !== "";
            });
            //console.debug(attrTextArr)
            var attrTextCount = attrTextArr.length
            //console.debug(tempaltSplashScreen, " ", (attrTextCount % 2), " ", this.state.imgTagCount, " === ", (attrTextCount / 2), "  ", attrTextCount)
            if (tempaltSplashScreen === '') {
                alert('"Title and Alternative Text for all Images in SplashScreen" is Empty. Please enter a valid text.');
                return;
            }
            if ((attrTextCount % 2) !== 0) {
                alert('Title or Alternative text is missing in "Title and Alternative Text for all Images in SplashScreen"');
                return;
            }

            if (this.state.imgTagCount !== (attrTextCount / 2)) {
                alert('Please enter a valid text for all images in "Title and Alternative Text for all Images in SplashScreen"');
                return;
            }
            var lastChar = tempaltSplashScreen[tempaltSplashScreen.length - 1];
            if (lastChar === ";") {
                alert('Please remove semicolon at the end of the text in "Title and Alternative Text for all Images in SplashScreen"');
                return;
            }
        }

        let assignment = { ...this.state.assignment };
        const categorySums = {}
        this.state.categories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            const questionCount = cat.question_count || 0;

            if (!categorySums[key]) {
                categorySums[key] = 0;
            }

            categorySums[key] += questionCount;
        });

        console.debug("categorySums>>??", categorySums)

        this.state.categories.forEach(cat => {
            let pickedCategoryKey = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            let masteryCount = cat.masteryCount;
            let noCQC = cat.nocqc;
            let randomSubcategoryOrder = cat.randomSubcategoryOrder;
            let required = cat.required;
            let noOfQuestion = 0; //cat.noOfQuestion;
            let atFirst = cat.atFirst;
            let atLast = cat.atLast;
            let availableQuestions = categorySums[pickedCategoryKey];

            console.debug("noOfQuestion>>??", pickedCategoryKey, noOfQuestion, availableQuestions)

            if (assignment.category_mastery_count === "" || assignment.category_mastery_count === "{}") {
                assignment.category_mastery_count = JSON.stringify({
                    [pickedCategoryKey]: masteryCount,
                });
            } else {
                const existingData = JSON.parse(assignment.category_mastery_count);
                existingData[pickedCategoryKey] = masteryCount;
                assignment.category_mastery_count = JSON.stringify(existingData);
            }

            if (assignment.category_nocqc === "" || assignment.category_nocqc === "{}") {
                assignment.category_nocqc = JSON.stringify({
                    [pickedCategoryKey]: noCQC,
                });
            } else {
                const existingData = JSON.parse(assignment.category_nocqc);
                existingData[pickedCategoryKey] = noCQC;
                assignment.category_nocqc = JSON.stringify(existingData);
            }

            if (assignment.random_subcategory_order === "" || assignment.random_subcategory_order === "{}") {
                assignment.random_subcategory_order = JSON.stringify({
                    [pickedCategoryKey]: randomSubcategoryOrder,
                });
            } else {
                const existingData = JSON.parse(assignment.random_subcategory_order);
                existingData[pickedCategoryKey] = randomSubcategoryOrder;
                assignment.random_subcategory_order = JSON.stringify(existingData);
            }

            if (assignment.category_is_required === "" || assignment.category_is_required === "{}") {
                assignment.category_is_required = JSON.stringify({
                    [pickedCategoryKey]: required,
                });
            } else {
                const existingData = JSON.parse(assignment.category_is_required);
                existingData[pickedCategoryKey] = required;
                assignment.category_is_required = JSON.stringify(existingData);
            }

            if (assignment.category_number_of_questions === "" || assignment.category_number_of_questions === "{}") {
                assignment.category_number_of_questions = JSON.stringify({
                    [pickedCategoryKey]: noOfQuestion !== 0 ? noOfQuestion : availableQuestions,
                });
            } else {
                const existingData = JSON.parse(assignment.category_number_of_questions);
                existingData[pickedCategoryKey] = noOfQuestion !== 0 ? noOfQuestion : availableQuestions;
                assignment.category_number_of_questions = JSON.stringify(existingData);
            }

            if (assignment.category_position === "" || assignment.category_position === "{}") {
                assignment.category_position = JSON.stringify({
                    [pickedCategoryKey]: {
                        category_at_begining: atFirst,
                        category_at_last: atLast,
                    },
                });
            } else {
                const existingData = JSON.parse(assignment.category_position);
                existingData[pickedCategoryKey] = {
                    category_at_begining: atFirst,
                    category_at_last: atLast,
                };
                assignment.category_position = JSON.stringify(existingData);
            }
        })

        console.debug("assignment>>??", assignment)

        let payload = {
            ...assignment,
            quiz_delete_arr: this.props.assignment?.quiz_details,
            splash_screen: this.state.splashScreenText,
            end_splash_screen: this.state.endSplashScreenText,
            alt_splash_screen: this.state.altSplashScreenText,
            start_date: "",
            start_time: "",
            end_date: "",
            end_time: "",
            quiz_delete_arr: [
                ...this.state.assignment.quiz_subcat_info,
                ...this.state.subcategories,
            ],
            quiz_details: this.state.subcategories,
            quiz_subcat_info: this.state.subcategories,
            free_choice_count: this.state.freeChoiceCount,
            allow_practice: assignment.quiz_type === 0, //all quizzes are practicable
            enable_subsection: this.state.enableSubSection,
            status: 0, // always UNPUBLISHED
        }

        // check if payload is valid
        if (payload.quiz_name === "") {
            NotificationManager.error("Assignment name cannot be empty");
            return;
        }

        // check if atlease one subcategories is present
        if (payload.quiz_subcat_info === null || payload.quiz_subcat_info === undefined || payload.quiz_subcat_info.length === 0) {
            NotificationManager.error("Atleast one subcategory should be added to the assignment");
            return
        }

        if (!this.validateSubcategoryOrder(this.state.subcategories)) {
            NotificationManager.error("Please ensure that all the subcategories of a category are placed sequentially next to each other and are not spread out.", "Invalid Subcategory Order", 3000);
            return false;
        }

        //console.debug("payload>>??", payload)
        if (this.props.librarySubjectID === null || this.props.librarySubjectID === undefined) {
            return;
        }
        console.debug("payload>>??", payload, this.state.categories);
        // return;
        this.setState({
            saveLoading: true,
        })
        console.debug("save assignment payload", payload);
        ApiRequestService({
            method: 'post',
            url: '/addQuiz',
            data: {
                ...payload,
                aml_subject_id: this.props.librarySubjectID
            }
        }).then(res => {
            if (res && res.data && res.data.data) {
                NotificationManager.success("Saved successully", "Success", 3000)
                this.setState({ saveLoading: false });
                this.props.onSaveAssignment(res.data.data);
            }
        }).finally(() => {
            this.setState({ saveLoading: false });
        })

    } */

    getFixedCategoryJSONStringify = (jsonString, subcats) => {
        const jsonObj = JSON.parse(jsonString);
        const newObj = {};
        subcats.forEach(subcat => {
            const key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;
            newObj[key] = jsonObj[key];
        });
        return JSON.stringify(newObj);
    }

    checkForOnePageModeValidation = (assignment) => {
        // randomize categories
        if (assignment.randomize_categories === 1 || assignment.randomize_categories === true) {
            NotificationManager.error('Please turn off Random category order ', 'One Page Test Mode', 5000);
            return false;
        }

        for (let i = 0; i < assignment.quiz_subcat_info.length; i++) {
            const quizInfo = assignment.quiz_subcat_info[i];
            if (quizInfo.randomize_questions === 1) {
                NotificationManager.error(`Please turn off random question order for the sucbategory - "${quizInfo.subcategory_name}"`, 'One Page Test Mode', 5000);
                return false;
            }
        }

        let randomSubcategoryOrderJSON = JSON.parse(assignment.random_subcategory_order);
        for (let key in randomSubcategoryOrderJSON) {
            if (randomSubcategoryOrderJSON[key] === 1) {
                NotificationManager.error(
                    `Please turn off random subcategory order for the all categories from Category Options`,
                    'One Page Test Mode',
                    5000
                );
                return false;
            }
        }

        let totalQuestionCount = 0;
        let categoryNoOfQuestionsJSON = JSON.parse(assignment.category_number_of_questions);
        for (let key in categoryNoOfQuestionsJSON) {
            totalQuestionCount += categoryNoOfQuestionsJSON[key];
        }

        console.debug("totalQuestionCount>>>", totalQuestionCount)
        if (totalQuestionCount > MAX_QUESTION_COUNT_FOR_ONE_PAGE_TEST) {
            NotificationManager.error(`Total no. of questions supported is less than or equal to ${MAX_QUESTION_COUNT_FOR_ONE_PAGE_TEST}. But you have added ${totalQuestionCount} questions`, 'One Page Test Mode', 5000);
            return false;
        }

        // check if at first or atlast turned ON: for one page mode, atfirst and atlast should be turned OFF
        let categoryPositionJSON = JSON.parse(assignment.category_position);
        if (categoryPositionJSON) {
            for (let key in categoryPositionJSON) {
                let valueObj = categoryPositionJSON[key];
                if (valueObj && (valueObj.category_at_begining === 1 || valueObj.category_at_last === 1)) {
                    NotificationManager.error("Please turn OFF all At First and At Last categories in category Option", 'One Page Test Mode', 5000);
                    return false;
                }
            }
        }

        return true;
    }

    handleSaveClick = (statusArg) => {
        // if (this.props.isLibrary) {
        //     this.handleSaveLibraryAssignment();
        //     return;
        // }

    
        let tempstartDate = this.state.startDate;
        let tempendDate = this.state.endDate;
        let startDate;
        let startTime;
        let endDate;
        let endTime;

        if (this.props.isLibrary === null || this.props.isLibrary === undefined && !this.props.isTutorial) {
            if (tempstartDate === "") {
                NotificationManager.error("Start date should not be empty");
                return;
            }
            if (tempendDate === "") {
                NotificationManager.error("End date should not be empty");
                return;
            }
            startDate = tempstartDate.format('DD/MM/YYYY');
            tempstartDate = tempstartDate.format('DD/MM/YYYY HH:mm').split(' ');
            startTime = tempstartDate[1];
    
            endDate = tempendDate.format('DD/MM/YYYY');
            tempendDate = tempendDate.format('DD/MM/YYYY HH:mm').split(' ');
            endTime = tempendDate[1];
        } else {
            startDate = "";
            startTime = "00:00:00"
            endDate = ""
            endTime = "00:00:00"
        }


        let tempAltSplashScreenText = this.state.altSplashScreenText;

        // Validate splash screen images
        if (this.state.imgTagCount >= 1) {
            const altArray = this.state.splashScreenAltText.map(img => `${img.title};${img.alt}`);
            const missing = this.state.splashScreenAltText.filter(img => !img.title?.trim() || !img.alt?.trim());

            // Basic field validation
            if (altArray.length === 0) {
                alert('"Title and Alternative Text for all Images in SplashScreen" is Empty. Please enter valid text.');
                return;
            }

            if (missing.length > 0) {
                alert('Title or Alternative text is missing for one or more images in SplashScreen.');
                return;
            }

            if (this.state.imgTagCount !== altArray.length) {
                alert('Number of image text entries does not match the number of images in SplashScreen.');
                return;
            }

            const combinedText = altArray.join(';').replace(/\n/g, '').replace(/ /g, '');
            if (combinedText.endsWith(';')) {
                alert('Please remove semicolon at the end of the text in "Title and Alternative Text for all Images in SplashScreen.');
                return;
            }

            this.setState({ altSplashScreenText: combinedText });
        }
        if (this.state.imgTagCountInEndSplashScreen >= 1) {
            const altArray = this.state.endSplashScreenAltText.map(img => `${img.title};${img.alt}`);
            const missing = this.state.endSplashScreenAltText.filter(img => !img.title?.trim() || !img.alt?.trim());

            // Basic field validation
            if (altArray.length === 0) {
                alert('"Title and Alternative Text for all Images in End SplashScreen" is Empty. Please enter valid text.');
                return;
            }

            if (missing.length > 0) {
                alert('Title or Alternative text is missing for one or more images in "End SplashScreen".');
                return;
            }

            if (this.state.imgTagCountInEndSplashScreen !== altArray.length) {
                alert('Number of image text entries does not match the number of images in "End SplashScreen".');
                return;
            }

            const combinedText = altArray.join(';').replace(/\n/g, '').replace(/ /g, '');
            if (combinedText.endsWith(';')) {
                alert('Please remove semicolon at the end of the text in "Title and Alternative Text for all Images in End SplashScreen".');
                return;
            }

            this.setState({ altEndSplashScreenText: combinedText });
        }

        let sectionList = [];
        // TODO: fix this when enable_subsections is turned ON
        if (this.state.enableSubSection) {
            this.state.selectedSectionAndSubsectionList.forEach(sec => {
                //console.debug("sec>>??", sec)
                sec.subsectionList.forEach(subSec => {
                    sectionList.push({
                        id: sec.section_id,
                        ...subSec,
                    });
                })
            })
        } else {
            this.state.selectedSectionIDArr.forEach(id => {
                let section = this.state.sections.find(sec => sec.section_id === id);
                if (section) {
                    sectionList.push({
                        id: section.section_id,
                        ...section
                    });
                }
            })
        }

        let sectionDeleteArr = [];
        const prevSections = this.props.assignment?.sections_list || [];
        const currentSections = sectionList || [];

        const makeKey = sec => `${sec.course_id}_${sec.id || sec.section_id}_${sec.subsection_id}`;

        // Collect sections that were in prev but not in current
        sectionDeleteArr = prevSections.filter(
            prevSec => !currentSections.some(curSec => makeKey(curSec) === makeKey(prevSec))
        );

        console.debug("sectionDeleteArr>>??", prevSections, currentSections, sectionDeleteArr)

        let assignment = { ...this.state.assignment };
        const categorySums = {}
        this.state.categories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            const questionCount = cat.question_count || 0;

            if (!categorySums[key]) {
                categorySums[key] = 0;
            }

            categorySums[key] += questionCount;
        });

        this.state.categories.forEach(cat => {
            let pickedCategoryKey = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            let masteryCount = cat.masteryCount;
            let noCQC = cat.nocqc;
            let randomSubcategoryOrder = cat.randomSubcategoryOrder;
            let required = cat.required;
            let noOfQuestion = cat.noOfQuestion;
            let atFirst = cat.atFirst;
            let atLast = cat.atLast;
            let availableQuestions = categorySums[pickedCategoryKey];

            if (!assignment.category_mastery_count || assignment.category_mastery_count === "" || assignment.category_mastery_count === "{}") {
                assignment.category_mastery_count = JSON.stringify({
                    [pickedCategoryKey]: masteryCount,
                });
            } else {
                const existingData = JSON.parse(assignment.category_mastery_count);
                existingData[pickedCategoryKey] = masteryCount;
                assignment.category_mastery_count = JSON.stringify(existingData);
            }

            if (!assignment.category_nocqc || assignment.category_nocqc === "" || assignment.category_nocqc === "{}") {
                assignment.category_nocqc = JSON.stringify({
                    [pickedCategoryKey]: noCQC,
                });
            } else {
                const existingData = JSON.parse(assignment.category_nocqc);
                existingData[pickedCategoryKey] = noCQC;
                assignment.category_nocqc = JSON.stringify(existingData);
            }

            if (!assignment.random_subcategory_order || assignment.random_subcategory_order === "" || assignment.random_subcategory_order === "{}") {
                assignment.random_subcategory_order = JSON.stringify({
                    [pickedCategoryKey]: randomSubcategoryOrder,
                });
            } else {
                const existingData = JSON.parse(assignment.random_subcategory_order);
                existingData[pickedCategoryKey] = randomSubcategoryOrder;
                assignment.random_subcategory_order = JSON.stringify(existingData);
            }

            if (!assignment.category_is_required || assignment.category_is_required === "" || assignment.category_is_required === "{}") {
                assignment.category_is_required = JSON.stringify({
                    [pickedCategoryKey]: required,
                });
            } else {
                const existingData = JSON.parse(assignment.category_is_required);
                existingData[pickedCategoryKey] = required;
                assignment.category_is_required = JSON.stringify(existingData);
            }

            if (!assignment.category_number_of_questions || assignment.category_number_of_questions === "" || assignment.category_number_of_questions === "{}") {
                assignment.category_number_of_questions = JSON.stringify({
                    [pickedCategoryKey]: noOfQuestion !== 0 ? noOfQuestion : availableQuestions,
                });
            } else {
                const existingData = JSON.parse(assignment.category_number_of_questions);
                existingData[pickedCategoryKey] = noOfQuestion !== 0 ? noOfQuestion : availableQuestions;
                assignment.category_number_of_questions = JSON.stringify(existingData);
            }

            if (!assignment.category_position || assignment.category_position === "" || assignment.category_position === "{}") {
                assignment.category_position = JSON.stringify({
                    [pickedCategoryKey]: {
                        category_at_begining: atFirst,
                        category_at_last: atLast,
                    },
                });
            } else {
                const existingData = JSON.parse(assignment.category_position);
                existingData[pickedCategoryKey] = {
                    category_at_begining: atFirst,
                    category_at_last: atLast,
                };
                assignment.category_position = JSON.stringify(existingData);
            }
        })

        const getKey = (subcat) =>
            `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}_${subcat.subcategory_id}`;

        //  Old vs new subcategories
        let arr = [];
        if (this.props.assignment?.quiz_details && this.props.assignment?.quiz_details?.length) {
            arr = [...this.props.assignment?.quiz_details];
        }
        if (this.state.removedSucbategories && this.state.removedSucbategories.length) {
            arr.push(...this.state.removedSucbategories);
        }
        const oldSubcats = arr;
        const newSubcats = this.state.subcategories || [];

        const oldKeys = new Set(oldSubcats.map(getKey));
        const newKeys = new Set(newSubcats.map(getKey));

        let insertArr = [];   // quiz_details
        let updateArr = [];   // quiz_subcat_info
        let deleteArr = [];   // quiz_delete_arr

        // Identify new and updated subcategories
        newSubcats.forEach(subcat => {
            const key = getKey(subcat);
            if (!oldKeys.has(key)) {
                insertArr.push(subcat); // New subcategory
            } else {
                updateArr.push(subcat); // Existing subcategory
            }
        });

        // Identify deleted subcategories
        oldSubcats.forEach(subcat => {
            const key = getKey(subcat);
            if (!newKeys.has(key)) {
                deleteArr.push(subcat);
            }
        });

        let payload = {
            ...assignment,
            splash_screen: this.state.splashScreenText,
            alt_splash_screen: this.state.splashScreenAltText.map(img => `${img.title};${img.alt}`).join(';'),
            end_splash_screen: this.state.endSplashScreenText,
            alt_end_splash_screen: this.state.endSplashScreenAltText.map(img => `${img.title};${img.alt}`).join(';'),
            start_date: startDate,
            start_time: startTime,
            end_date: endDate,
            end_time: endTime,
            sections_delete_list: sectionDeleteArr,
            sections_list: sectionList,
            quiz_details: insertArr,       // only new ones
            quiz_subcat_info: updateArr,   // only existing ones
            quiz_delete_arr: deleteArr,
            free_choice_count: this.state.freeChoiceCount,
            allow_practice: assignment.quiz_type === 0, //all quizzes are practicable
            enable_subsection: this.state.enableSubSection,
            status: statusArg,
            allow_partial_credit: assignment.quiz_type === 1 ? false : assignment.allow_partial_credit,
            allow_pause_category: assignment.quiz_type === 1 ? false : assignment.allow_pause_category,
            is_practice_assignment: assignment.is_practice_assignment,
        }

        console.debug("payload>>??", payload)

        // TODO check if payload is valid
        if (payload.one_page_mode && !this.checkForOnePageModeValidation(payload)) {
            return;
        }

        if (payload.quiz_name === "") {
            NotificationManager.error("Assignment name cannot be empty");
            return;
        }


        if (this.props.isLibrary === null || this.props.isLibrary === undefined && !this.props.isTutorial) {
            if (payload.start_date === "" || payload.start_time === "" || payload.end_date === "" || payload.end_time === "") {
                NotificationManager.error("Please fill the date fields");
                return;
            }
        }

        if (this.props.isLibrary === null || this.props.isLibrary === undefined && !this.props.isTutorial) {
            if (payload.sections_list === null || payload.sections_list?.length === 0) {
                let msg = "Please add atleast one section"
                if (payload.enable_subsection) {
                    msg = "Please add atleast one section & subsection"
                }
                NotificationManager.error(msg);
                return;
            }
        }

        // check if atlease one subcategories is present
        if (
            (payload.quiz_subcat_info === null || payload.quiz_subcat_info === undefined || payload.quiz_subcat_info.length === 0)
            &&
            (payload.quiz_details === null || payload.quiz_details === undefined || payload.quiz_details.length === 0)
        ) {
            NotificationManager.error("Atleast one subcategory should be added to the assignment");
            return
        }

        if (!this.validateSubcategoryOrder(this.state.subcategories)) {
            NotificationManager.error("Please ensure that all the subcategories of a category are placed sequentially next to each other and are not spread out.", "Invalid Subcategory Order", 3000);
            return false;
        }

        //console.debug("payload>>??", payload)

       
        let arrOfCategories = [...payload.quiz_subcat_info, ...payload.quiz_details];
        payload.category_is_required = this.getFixedCategoryJSONStringify(payload.category_is_required, arrOfCategories);
        payload.category_mastery_count = this.getFixedCategoryJSONStringify(payload.category_mastery_count, arrOfCategories);
        payload.category_nocqc = this.getFixedCategoryJSONStringify(payload.category_nocqc, arrOfCategories);
        payload.category_number_of_questions = this.getFixedCategoryJSONStringify(payload.category_number_of_questions, arrOfCategories);
        payload.category_position = this.getFixedCategoryJSONStringify(payload.category_position, arrOfCategories);
        payload.random_subcategory_order = this.getFixedCategoryJSONStringify(payload.random_subcategory_order, arrOfCategories);

        if (this.props.isLibrary) {
            payload.aml_subject_id = this.props.librarySubjectID
            payload.aml_topic_id = this.props.libraryTopicID
        }

        console.debug("save assignment payload>>??", payload);
        // return;

         if (statusArg === 0) {
            this.setState({
                saveLoading: true,
            })
        } else {
            this.setState({
                savePublishLoading: true,
            })
        }   

        // If assignment is tutorial
        if (this.props.isTutorial) {
            payload.is_tutorial = true;
            payload.is_nongraded = 1;
            payload.tutorial_key = this.props.tutorialKey;
        }

        ApiRequestService({
            method: 'post',
            url: '/addQuiz',
            data: payload
        }).then(res => {
            // Status, not the data slot: a save refused by the sync coverage gate
            // answers FAIL carrying the rows that blocked it, so data being
            // present no longer means the save went through.
            if (res && res.data && res.data.status === 0 && res.data.data) {
                let message = "Saved successully";
                if (statusArg === 1) {
                    message = "Saved & Published successully"
                }
                this.setState({
                    removedSucbategories: [],
                })
                NotificationManager.success(message, "Success", 3000)
               /*  this.setState({
                    saveLoading: false, assignment: {
                        ...payload,
                        quiz_id: res.data.data.quiz_id,
                    }
                });
                let arr = [...payload.quiz_details, ...payload.quiz_subcat_info];
                this.props.onSaveAssignment({
                    ...payload,
                    quiz_details: arr,
                    quiz_subcat_info: arr,
                    quiz_id: res.data.data.quiz_id,
                }); */
                this.getQuizByID(payload.course_id, payload?.section_id, res.data.data.quiz_id);
                if (this.state.isQuizAttended) {
                    this.handleResetPreviewBtnClick();
                }
            } else {
                // A library assignment refused by the sync gate answers with the
                // blocking rows; they go in the table rather than an alert, which
                // cannot be read back or copied once it is dismissed.
                const validation = res && res.data && res.data.data;
                if (validation && validation.unsynced_categories) {
                    this.setState({ unsyncedCategories: validation.unsynced_categories });
                } else if (res && res.data && res.data.message) {
                    alert(res.data.message)
                }
            }
        }).finally(() => {
            this.setState({ saveLoading: false, savePublishLoading: false, });
        })

    }

    getQuizByID = (courseID, sectionID, quizID) => {
        let payload = {
            course_id: courseID,
            section_id: sectionID,
            quiz_id: quizID,
        }
        ApiRequestService({
            method: 'post',
            url: '/getQuizById',
            data: payload
        }).then(res => {
            if (res.data.data !== null && res.data.data !== undefined && res.data.data.quiz_id) {
                this.setState({
                    assignment: res.data.data
                })
                this.props.onSaveAssignment(res.data.data);
            }
        }).finally(() => {
            this.setState({
                saveLoading: false, savePublishLoading: false
            })
        })
    }

    markInvalidSubcategoryOrder = (subcategories) => {
        const seenCategoryKeys = [];
        const lastSeenIndex = {};
        let updatedSubcategories = subcategories.map((subcat, index) => {
            const key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;
            const isNewGroup = !seenCategoryKeys.includes(key);

            if (isNewGroup) {
                seenCategoryKeys.push(key);
                lastSeenIndex[key] = index;
                return { ...subcat, invalid: false };
            } else {
                // If it's continuing the group
                if (seenCategoryKeys[seenCategoryKeys.length - 1] === key) {
                    lastSeenIndex[key] = index;
                    return { ...subcat, invalid: false };
                } else {
                    // It's reappearing after other groups appeared in between — INVALID
                    return { ...subcat, invalid: true };
                }
            }
        });

        return updatedSubcategories;
    };

    validateSubcategoryOrder = (subcategories) => {
        const seenCategoryKeys = [];
        const categoryKeyMap = subcategories.map(subcat =>
            `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`
        );

        for (let i = 0; i < categoryKeyMap.length; i++) {
            const key = categoryKeyMap[i];

            // If it's a new key, push it
            if (!seenCategoryKeys.includes(key)) {
                seenCategoryKeys.push(key);
            } else {
                // If key was seen earlier and is not the most recent, it's an interleaving
                if (seenCategoryKeys[seenCategoryKeys.length - 1] !== key) {
                    return false; // Invalid order
                }
            }
        }

        return true; // Valid order
    };

    onSplashScreenTextChange = value => {
        this.setState({ splashTextEditorObj: value });
        let enteredString = TextEditor.getHTMLStringFromEditorState(value);
        if (enteredString !== null) {
            this.setState({ splashScreenText: enteredString });
        }
        var imgTagCount = enteredString.split('<img ').length - 1
        if (imgTagCount > 0) {
            let imageAltText = Array.isArray(this.state.splashScreenAltText)
                    ? [...this.state.splashScreenAltText]
                    : [];

                // Add empty entries if new images are added
                while (imageAltText.length < imgTagCount) {
                    imageAltText.push({ title: "", alt: "" });
                }

                // Trim extras if images are removed
                if (imageAltText.length > imgTagCount) {
                    imageAltText = imageAltText.slice(0, imgTagCount);
                }


                this.setState({
                    altSplashScreenTextVisible: true,
                    imgTagCount: imgTagCount,
                    splashScreenAltText: imageAltText
                });
        } else {
            this.setState({
                altSplashScreenTextVisible: false,
                imgTagCount: 0,
                splashScreenAltText: []
            });
        }
    };


onEndSplashScreenTextChange = (value) => {
    this.setState({ endSplashTextEditorObj: value });
    let enteredString = TextEditor.getHTMLStringFromEditorState(value);

    if (enteredString !== null) {
        this.setState({ endSplashScreenText: enteredString });
    }

    const imgTagCount = enteredString ? enteredString.split('<img ').length - 1 : 0;

    if (imgTagCount > 0) {
        let imageAltText = Array.isArray(this.state.endSplashScreenAltText)
                ? [...this.state.endSplashScreenAltText]
                : [];

            // Add empty entries if new images are added
            while (imageAltText.length < imgTagCount) {
                imageAltText.push({ title: "", alt: "" });
            }

            // Trim extras if images are removed
            if (imageAltText.length > imgTagCount) {
                imageAltText = imageAltText.slice(0, imgTagCount);
            }


            this.setState({
                altSplashEndScreenTextVisible: true,
                imgTagCountInEndSplashScreen: imgTagCount,
                endSplashScreenAltText: imageAltText
            });
    } else {
        this.setState({
            altSplashEndScreenTextVisible: false,
            imgTagCountInEndSplashScreen: 0,
            endSplashScreenAltText: []
        });
    }
};
    handleChangeStartDate = (timeString, sDate, event) => {
        if (sDate !== null) {
            this.setState({
                startDate: moment(sDate)
            });
        }
    }

    handleChangeEndDate = (eDate, id) => {
        if (eDate !== null) {
            let date = moment(eDate)
            if (id === "date") {
                date.set({ "h": 23, "m": 59 })
            }
            this.setState({
                endDate: date
            });
        }
    }


    handleSectionSelect = (event) => {
        let selectedSectionIDArr = event.target.value;
        this.setState({
            selectedSectionIDArr,
        })
    }

    onSaveCategoryOption = (updatedCategories, freeChoiceCount) => {

        //console.debug("updatedCategories>>??", updatedCategories)

        let updatedSubcategories = [];

        const atFirstKeys = new Set();
        const atLastKeys = new Set();

        updatedCategories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            if (cat.atFirst) atFirstKeys.add(key);
            else if (cat.atLast) atLastKeys.add(key);
        });

        let middleSubcats = [];
        let lastSubcats = [];
        let order = 1;

        this.state.subcategories.forEach(subcat => {
            const key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;

            if (atFirstKeys.has(key)) {
                updatedSubcategories.push({
                    ...subcat,
                    order: order++,
                });
            } else if (atLastKeys.has(key)) {
                lastSubcats.push(subcat);
            } else {
                middleSubcats.push(subcat);
            }
        });

        middleSubcats.forEach(subcat => {
            updatedSubcategories.push({
                ...subcat,
                order: order++,
            });
        });

        lastSubcats.forEach(subcat => {
            updatedSubcategories.push({
                ...subcat,
                order: order++,
            });
        });

        this.setState({
            categories: updatedCategories,
            showCategoryOptions: false,
            freeChoiceCount: freeChoiceCount
        }, () => {
            this.setState({ subcategories: updatedSubcategories });
        });
    }

    handlePreviewClick = () => {
        let strToRemove = 'cpanel/'
        let url = (this.appProperties.appURL)
        url = url.replace(strToRemove, "");
        if (process.env.hasOwnProperty("REACT_APP_APPSETTING_REQUIRED")) {
            let hostArray = window.location.hostname.split(".");
            if (hostArray.length > 4) {
                url = `${window.location.protocol}//${hostArray[hostArray.length - 5]}.student.${hostArray[hostArray.length - 3]}.${hostArray[hostArray.length - 2]}.${hostArray[hostArray.length - 1]}/`
            } else if (hostArray.length == 4) {
                url = `${window.location.protocol}//${hostArray[hostArray.length - 4]}.student.${hostArray[hostArray.length - 2]}.${hostArray[hostArray.length - 1]}/`
            }
        }
        if (this.appProperties.loginType === "shiboleth") {
            url = url + "student/";
        }

        // Validation
        if (this.props.isTutorial !== true && this.state.selectedSectionIDArr.length === 0) {
            NotificationManager.error("Please select a section and save the assignment to preview it.", "ERROR", 3000);
            return;
        }

        if (this.state.categories.length === 0) {
            NotificationManager.error("Please add atleast one category/subcategory", "ERROR", 3000);
            return;
        }


        let selectSectionID = "";
        if (this.state.selectedSectionIDArr && this.state.selectedSectionIDArr.length) {
            selectSectionID = this.state.selectedSectionIDArr[0];
        }

        // For local dev 
        if (url.includes("localhost")) {
            url = url.replace("3000", "3001/");
        }

        let tempQuizID = this.state.assignment.quiz_id;
        let tempCourseID = this.state.assignment.course_id;
        let tempSectionID = selectSectionID;
        let tempQuizName = this.state.assignment.quiz_name;
        let tempQuizType = this.state.assignment.quiz_type;

        if (this.props.isTutorial) {
            tempCourseID = -1;
            tempSectionID = -1;
        }

        url = url + `takequiz?quiz_id=${tempQuizID}&course_id=${tempCourseID}&section_id=${tempSectionID}&quiz_name=${tempQuizName}&quiz_type=${tempQuizType}`

        console.log("AppURL=", url)

        this.setState({
            isQuizAttended: true,
        });
        this.props.onAfterPreviewClick(this.state.assignment.quiz_id);
        window.open(url)
    }

    handleRemoveSubcategory = (index) => {
        let updatedSubcategories = [...this.state.subcategories];
        let removedSubcat = {...updatedSubcategories[index]};
        this.setState({
            removedSucbategories: [...this.state.removedSucbategories, removedSubcat]
        })
        updatedSubcategories.splice(index, 1);
        this.changeSubcategoriesOrder(updatedSubcategories);
    }

    changeSubcategoriesOrder = (subcategories) => {
        // Based on subcategories at first and at last
        // change the order 
        let updatedSubcategories = []

        const atFirstKeys = new Set();
        const atLastKeys = new Set();

        this.state.categories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            if (cat.atFirst) atFirstKeys.add(key);
            else if (cat.atLast) atLastKeys.add(key);
        });

        let middleSubcats = [];
        let lastSubcats = [];
        let order = 1;

        subcategories.forEach(subcat => {
            const key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;

            if (atFirstKeys.has(key)) {
                updatedSubcategories.push({
                    ...subcat,
                    order: order++,
                });
            } else if (atLastKeys.has(key)) {
                lastSubcats.push(subcat);
            } else {
                middleSubcats.push(subcat);
            }
        });

        middleSubcats.forEach(subcat => {
            updatedSubcategories.push({
                ...subcat,
                order: order++,
            });
        });

        lastSubcats.forEach(subcat => {
            updatedSubcategories.push({
                ...subcat,
                order: order++,
            });
        });

        let updatedCategories = [];
        this.state.categories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            // check if key is present in sucbategories
            let index = updatedSubcategories?.findIndex(subcat => {
                let subcatKey = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;
                return subcatKey === key;
            })
            if (index !== -1) {
                updatedCategories.push(cat);
            }
        })

        this.setState({
            categories: updatedCategories,
            subcategories: updatedSubcategories,
        })
    }

    onSaveSectionSubsection = (data, editMode, oldData) => {
        let selectedSectionAndSubsectionList = [...this.state.selectedSectionAndSubsectionList];
        if (editMode) {
            let index = selectedSectionAndSubsectionList?.findIndex(sec => sec.section_id === oldData.section_id);
            if (index > -1) {
                selectedSectionAndSubsectionList[index] = data;
            }
        } else {
            selectedSectionAndSubsectionList.push(data);
        }
        this.setState({
            selectedSectionAndSubsectionList,
        })
    }

    onDeleteSectionSubsection = (index) => {
        if (index > -1) {
            let selectedSectionAndSubsectionList = [...this.state.selectedSectionAndSubsectionList];
            selectedSectionAndSubsectionList.splice(index, 1);
            this.setState({
                selectedSectionAndSubsectionList,
            })
        }
    }

    // Convert selectedSectionAndSubsectionList to compound keys for the select field
    getSubsectionSelectValue = () => {
        const keys = [];
        this.state.selectedSectionAndSubsectionList.forEach(sec => {
            sec.subsectionList.forEach(sub => {
                keys.push(`${sec.section_id}_${sub.subsection_id}`);
            });
        });
        return keys;
    }

    // Handle changes from the grouped select field
    handleSubsectionSelectChange = (selectedKeys) => {
        // Group selected keys by section_id
        const grouped = {};
        selectedKeys.forEach(key => {
            const [sectionId, subsectionId] = key.split('_').map(Number);
            if (!grouped[sectionId]) {
                grouped[sectionId] = [];
            }
            grouped[sectionId].push(subsectionId);
        });

        // Build selectedSectionAndSubsectionList from grouped keys
        const selectedSectionAndSubsectionList = [];
        Object.keys(grouped).forEach(sectionIdStr => {
            const sectionId = Number(sectionIdStr);
            const section = this.state.sections.find(sec => sec.section_id === sectionId);
            if (!section) return;

            const subsectionIds = grouped[sectionId];
            const matchedSubs = this.state.subsections.filter(
                sub => sub.section_id === sectionId && subsectionIds.includes(sub.subsection_id)
            );

            selectedSectionAndSubsectionList.push({
                section_id: sectionId,
                section_name: section.section_name,
                subsectionList: matchedSubs,
                subsection: matchedSubs.map(sub => sub.subsection_name),
            });
        });

        this.setState({ selectedSectionAndSubsectionList });
    }

    onAddSubcategories = (selectedSubcategories, subjectName, topicName, categoryName) => {

        // Check if the selected subcategories are already added
        console.debug("selectedSubcategories>>??", selectedSubcategories, this.state.subcategories);
        let alreadyExists = selectedSubcategories.some(selectedSubcat => {
            let data = selectedSubcat.data;
            let key = `${data.subject_id}_${data.topic_id}_${data.category_id}_${data.subcategory_id}`;
            return this.state.subcategories?.some(subcat => {
                let subcatKey = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}_${subcat.subcategory_id}`;
                return key === subcatKey;
            });
        });

        if (alreadyExists) {
            NotificationManager.error("Subcategories are aleady added. Please unselect them")
            return false;
        }

        let newSubcategories = [];
        if (this.state.subcategories && this.state.subcategories.length) {
            newSubcategories = [...this.state.subcategories];
        }
        let subcategoriesCount = newSubcategories.length;
        selectedSubcategories.forEach(ss => {
            const selectedSucbat = ss.data;

            // check if this subcat is already added in the subcategories list
            let key = `${selectedSucbat.subject_id}_${selectedSucbat.topic_id}_${selectedSucbat.category_id}_${selectedSucbat.subcategory_id}`
            let index = -1;
            if (this.state.subcategories && this.state.subcategories.length) {
                index = this.state.subcategories?.findIndex(subcat => {
                    let subcatKey = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}_${subcat.subcategory_id}`;
                    return key === subcatKey;
                });
            }
            console.debug("index>>??", index)
            if (index === -1) {
                subcategoriesCount++;
                let subcategory = {
                    subject_id: selectedSucbat.subject_id,
                    topic_id: selectedSucbat.topic_id,
                    category_id: selectedSucbat.category_id,
                    subcategory_id: selectedSucbat.subcategory_id,
                    subject_name: subjectName,
                    topic_name: topicName,
                    category_Name: categoryName,
                    category_name: categoryName,
                    subcategory_name: selectedSucbat.subcategory_name,
                    index: "",
                    order: subcategoriesCount,
                    randomize_questions: 1,
                    subcategory_weight: selectedSucbat.subcategory_weight ? selectedSucbat.subcategory_weight : 1,
                    non_graded: 0,
                    enable_analytics: false,
                    enable_feedback: true,
                    question_count: selectedSucbat.question_count,
                }
                newSubcategories.push(subcategory);
            }

        })

        let newCategories = [];
        let seenCategoryKeys = new Set();
        if (this.state.categories && this.state.categories.length) {
            this.state.categories.forEach(cat => {
                const catKey = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
                if (!seenCategoryKeys.has(catKey)) {
                    newCategories.push(cat);
                }
                seenCategoryKeys.add(catKey);
            });
            // newCategories = [...this.state.categories];
        }
        newSubcategories.forEach(category => {
            const catKey = `${category.subject_id}_${category.topic_id}_${category.category_id}`;
            if (!seenCategoryKeys.has(catKey)) {
                let cat = {
                    ...category,
                    masteryCount: this.state.assignment.mastery_condition ? this.state.assignment.mastery_condition : DEFAULT_MASTERY_COUNT,
                    nocqc: DEFAULT_NOCQC,
                    randomSubcategoryOrder: DEFAULT_RADNOM_SUBCATEGORY_ORDER,
                    required: DEFAULT_REQUIRED,
                    atFirst: DEFAULT_AT_FIRST,
                    atLast: DEFAULT_AT_LAST,
                    noOfQuestion: 0,
                    category_name: categoryName,
                    subject_name: subjectName,
                    topic_name: topicName,
                }
                newCategories.push(cat);
            }
            seenCategoryKeys.add(catKey);
        });

        // console.debug("newSubcategories>>??", newSubcategories, newCategories, seenCategoryKeys, this.state.assignment.quiz_details);

        // Show success notification
        const addedCount = selectedSubcategories.length;
        NotificationManager.success(
            `${addedCount} subcategor${addedCount > 1 ? 'ies' : 'y'} successfully added to the table`,
            'Success',
            3000
        );

        this.setState({
            subcategories: newSubcategories,
            categories: newCategories,
        });
    }

    handleResetPreviewBtnClick = (quizID) => {
        if (this.props.handleResetPreview) {
            this.setState({
                isQuizAttended: false,
            })
            this.props.handleResetPreview(quizID, true, true)
        } else {
            this.handleDeleteUserDataForQuiz(true);
        }
    }

    render() {
        let seenCategoryKeys = new Set();
        const { assignment } = this.state;

        let categoryMasteryCountJSON = assignment?.category_mastery_count ? JSON.parse(assignment.category_mastery_count) : {};
        let categoryNocqcJSON = assignment?.category_nocqc ? JSON.parse(assignment.category_nocqc) : {};
        let randomSubcategoryOrderJSON = assignment?.random_subcategory_order ? JSON.parse(assignment.random_subcategory_order) : {};
        let categoryIsRequiredJSON = assignment?.category_is_required ? JSON.parse(assignment.category_is_required) : {};
        let categoryPositionJSON = assignment?.category_position ? JSON.parse(assignment.category_position) : {};


        let startDateLocal = moment(this.state.startDate).toDate();
        let endtDateLocal = moment(this.state.endDate).toDate();

        const isValidDate = function (d) {
            return d instanceof Date && !isNaN(d);
        }

        //console.debug("this.state.selectedSectionIDArr>>??", this.state.selectedSectionIDArr)
        return (
            <Dialog
                open={this.props.showModal}
                // fullWidth
                // maxWidth="lg"
                fullScreen
                className='assign-detail-dialog'
            >
                <DialogTitle style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}>
                    <Typography fontSize={18} fontWeight={600}>
                        {assignment ? assignment.quiz_name : "Assignment"} - Details:
                        {this.props.readOnly ?
                            <span style={{ marginLeft: "12px", fontSize: "0.85rem", fontWeight: 400, color: "#727C8E" }}>
                                (Read only - {READ_ONLY_HINT})
                            </span>
                            : null}
                    </Typography>
                    {this.state.assignment !== null && this.state.assignment?.quiz_id !== null ?
                        <div className=''>
                            <Button
                                style={{
                                    marginRight: "2rem"
                                }}
                                variant='contained' onClick={this.handlePreviewClick}>
                                {this.state.isQuizAttended ? "Resume Preview" : "Preview"}
                            </Button>
                            {this.state.isQuizAttended ?
                                <Button
                                    disabled={this.state.resetPreviewLoading}
                                    style={{
                                        marginRight: "2rem"
                                    }}
                                    variant='contained' onClick={() => {
                                        this.handleResetPreviewBtnClick(assignment?.quiz_id)
                                    }}>
                                    Reset Preview
                                    <div className='abs-center'>
                                        {this.state.resetPreviewLoading && (
                                            <CircularProgress size={20} />
                                        )}
                                    </div>
                                </Button>
                                : null}
                        </div>
                        : null}
                </DialogTitle>

                <Tooltip
                    title={<Typography className='text-white' fontSize={14}>
                        Close
                    </Typography>}
                    placement='top'
                    arrow
                >
                    <IconButton
                        aria-label="close"
                        sx={(theme) => ({
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        })}
                        onClick={this.props.handleClose}
                    >
                        <IoMdCloseCircleOutline fontSize={24} />
                    </IconButton>
                </Tooltip>
                <DialogContent>
                    {/* A fieldset disables every native input inside it at once;
                        pointer-events covers the custom widgets that are not inputs.
                        The footer is outside it, so Close still works. */}
                    <fieldset disabled={!!this.props.readOnly} style={{
                        border: 0, padding: 0, margin: 0, minWidth: 0,
                        pointerEvents: this.props.readOnly ? "none" : undefined,
                    }}>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <div style={{
                                fontWeight: 600,
                            }}>
                                {this.props.isTutorial ? "Tutorial Name" : "Assignment Name"}
                            </div>
                            <TextField
                                size='small'
                                placeholder={this.props.isTutorial ? "Enter tutorial name" :"Enter assignment name"}
                                value={assignment?.quiz_name}
                                onChange={e => {
                                    let updatedValue = e.target.value;
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            quiz_name: updatedValue,
                                        }
                                    }));
                                }}
                                variant="standard"
                                id="assignment-name"
                                sx={{
                                    width: "100%",
                                    '& .MuiInputBase-root': {
                                        height: '40px',
                                        borderRadius: '6px'
                                    }
                                }}
                            />
                        </Grid>
                        {this.props.isLibrary || this.props.isTutorial ? null :
                            <React.Fragment>
                                <Grid item xs={2}>
                                    <SFDatePicker 
                                        id="start-date"
                                        label="Start Date"
                                        placeholder={"MM/DD/YYYY"}
                                        value={isValidDate(startDateLocal) ? startDateLocal : null}
                                        onDatePickerChange={this.handleChangeStartDate}
                                        onDateChange={(dateText) => {
                                            this.setState({
                                                startDate:  moment(dateText, "MM/DD/YYYY")
                                            })
                                        }}
                                        showLabel={true}
                                    />
                                    {/* <DatePicker
                                        id="startDate"
                                        label="Start Date"
                                        displayMode="portrait"
                                        value={isValidDate(startDateLocal) ? startDateLocal : null}
                                        onChange={this.handleChangeStartDate}
                                    /> */}
                                </Grid>
                                <Grid item xs={2}>
                                    <TimePicker
                                        id="startTime"
                                        label="Start Time"
                                        displayMode="portrait"
                                        value={isValidDate(startDateLocal) ? startDateLocal : null}
                                        onChange={this.handleChangeStartDate}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <SFDatePicker 
                                        id="end-date"
                                        label="End Date"
                                        placeholder={"MM/DD/YYYY"}
                                        value={isValidDate(endtDateLocal) ? endtDateLocal : null}
                                        onDatePickerChange={(_, date) => {
                                            this.handleChangeEndDate(date, "date")
                                        }}
                                        onDateChange={(dateText) => {
                                            let endDate = moment(dateText, "MM/DD/YYYY");
                                            endDate.set({ "h": 23, "m": 59 });
                                            this.setState({
                                                endDate: endDate
                                            })
                                        }}
                                        showLabel={true}
                                    />
                                    {/* <DatePicker
                                        id="endDate"
                                        label="End Date"
                                        displayMode="portrait"
                                        value={isValidDate(endtDateLocal) ? endtDateLocal : null}
                                        onChange={(_, date) => this.handleChangeEndDate(date, "date")}
                                    /> */}
                                </Grid>
                                <Grid item xs={2}>
                                    <TimePicker
                                        id="endTime"
                                        label="End Time"
                                        displayMode="portrait"
                                        value={isValidDate(endtDateLocal) ? endtDateLocal : null}
                                        onChange={(_, date) => this.handleChangeEndDate(date, "time")}
                                    />
                                </Grid>
                            </React.Fragment>
                        }
                    </Grid>

                    {/* 2nd row */}
                    <div className='row-containers' style={{ alignItems: "flex-start" }}>
                        {/* Common items */}
                        {this.props.isAssessment ? null :
                        <Box component="fieldset" className='row-containers'>
                            <legend>Common</legend>
                            <div className='checkbox-container' onClick={() => {
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        randomize_categories: prevState.assignment?.randomize_categories === 1 ? 0 : 1,
                                    }
                                }));
                            }}>
                                <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.randomize_categories === 1} icons={false} className='custom-react-toggle' />
                                <Header name="Random Category Order" tooltip={this.helpTextModel.getHelpTextForKey('Random category order')} />
                            </div>
                            <div className='checkbox-container' onClick={() => {
                                if (this.props.isTutorial) return;
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        is_nongraded: prevState.assignment?.is_nongraded === 1 ? 0 : 1,
                                    }
                                }));
                            }}>
                                <Toggle 
                                disabled={this.props.isTutorial}
                                onClick={(e) => e.stopPropagation()} checked={
                                    this.props.isTutorial ? true :
                                    assignment?.is_nongraded === 1
                                } icons={false} className='custom-react-toggle' />
                                <Header name="Non Graded" tooltip={this.helpTextModel.getHelpTextForKey('Non Graded')} />
                            </div>
                            <div className='checkbox-container' onClick={() => {
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        show_calculator: prevState.assignment?.show_calculator === 1 ? 0 : 1,
                                    }
                                }));
                            }}>
                                <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.show_calculator === 1} icons={false} className='custom-react-toggle' />
                                <Header name="Show Calculator" tooltip={this.helpTextModel.getHelpTextForKey('Show Calculator')} />
                            </div>
                         
                            <div className='checkbox-container' onClick={() => {
                                
                            }}>
                                <FormControl >
                                    {/* <FormLabel>Assignment</FormLabel> */}
                                    <RadioGroup
                                        row
                                        value={assignment?.quiz_type ? assignment.quiz_type : 0}
                                        name="row-radio-buttons-group"
                                        style={{
                                            display: "flex",
                                            alignItems: "center"
                                        }}
                                        onChange={() => {
                                            this.setState(prevState => ({
                                                assignment: {
                                                    ...prevState.assignment,
                                                    quiz_type: prevState.assignment?.quiz_type === 1 ? 0 : 1,
                                                }
                                            }));
                                        }}
                                    >
                                        <FormControlLabel value={0} control={<Radio />} label="Mastery" />
                                        <FormControlLabel value={1} control={<Radio />} label="Test" />
                                        <Tooltip
                                            title={<Typography className='text-white' fontSize={14}>
                                                {this.helpTextModel.getHelpTextForKey('Test Mode')}
                                            </Typography>}
                                            placement='top'
                                            arrow
                                        >
                                            <span>
                                                <BsInfoCircleFill color='#737373' size={14}
                                                    style={{
                                                        flexShrink: 0,
                                                        minWidth: "12px",
                                                        minHeight: "12px",
                                                        verticalAlign: "middle",
                                                        cursor: "pointer",
                                                    }} />
                                            </span>
                                        </Tooltip>
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div style={{display:"flex"}} 
                                onClick={() => {
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            is_practice_assignment: !prevState.assignment?.is_practice_assignment,
                                        }
                                    }));
                                }}
                            >
                                {/* Practice Assignment Toggle  */}
                                <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.is_practice_assignment} icons={false} className='custom-react-toggle' />
                                <Header name="Practice Assignment" tooltip={this.helpTextModel.getHelpTextForKey("Practice Assignment")} />
                            </div>
                        </Box>
                        }

                        {/* Quiz Related */}
                        {assignment?.quiz_type === 0 && !this.props.isTutorial ?
                            <Box component="fieldset" className='row-containers'>
                                <legend>Quiz</legend>
                                <div className='checkbox-container' onClick={() => {
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            allow_partial_credit: !prevState.assignment?.allow_partial_credit,
                                        }
                                    }));
                                }}>
                                    <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.allow_partial_credit} icons={false} className='custom-react-toggle' />
                                    <Header name="Allow Partial Credit" tooltip={this.helpTextModel.getHelpTextForKey('Allow Partial Credit')} />
                                </div>
                                <div className='checkbox-container' onClick={() => {
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            allow_pause_category: !prevState.assignment?.allow_pause_category,
                                        }
                                    }));
                                }}>
                                    <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.allow_pause_category} icons={false} className='custom-react-toggle' />
                                    <Header name="Allow Pause Category" tooltip={this.helpTextModel.getHelpTextForKey('Allow Pause Category')} />
                                </div>
                            </Box>
                            : null}

                        {/* Test Related  */}
                        {assignment?.quiz_type === 1 ?
                            <Box component="fieldset" className='row-containers'>
                                <legend>Test</legend>
                                {this.props.isAssessment ? null :
                                <React.Fragment>
                                    <div className='checkbox-container' onClick={() => {
                                        this.setState(prevState => ({
                                            assignment: {
                                                ...prevState.assignment,
                                                one_page_mode: prevState.assignment?.one_page_mode ? false : true,
                                            }
                                        }));
                                    }}>
                                        <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.one_page_mode} icons={false} className='custom-react-toggle' />
                                        <Header name="One Page Mode" tooltip={this.helpTextModel.getHelpTextForKey('One Page Mode')} />
                                    </div>
                                    <div className='checkbox-container' onClick={() => {
                                        this.setState(prevState => ({
                                            assignment: {
                                                ...prevState.assignment,
                                                fullScoreIfAttempted: prevState.assignment?.fullScoreIfAttempted === 1 ? 0 : 1,

                                            }
                                        }));
                                    }}>
                                        <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.fullScoreIfAttempted === 1} icons={false} className='custom-react-toggle' />
                                        <Header name="Award full score if completed" tooltip={this.helpTextModel.getHelpTextForKey('Award full score if completed')} />
                                    </div>
                                </React.Fragment>
                                }
                                <div className='checkbox-container' onClick={() => {
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            testTimerEnabled: prevState.assignment?.testTimerEnabled === 1 ? 0 : 1,

                                        }
                                    }));
                                }}>
                                    <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.testTimerEnabled === 1} icons={false} className='custom-react-toggle' />
                                    <Header name="Test Time" tooltip={this.helpTextModel.getHelpTextForKey('Test Time')} />
                                </div>
                                {assignment?.testTimerEnabled === 1 ?
                                    <div style={{display: 'flex', gap:'8px'}}>
                                        <div className='checkbox-container' onClick={() => {
                                            this.setState(prevState => ({
                                                assignment: {
                                                    ...prevState.assignment,
                                                    fixedAbsoluteTimeEnabled: prevState.assignment?.fixedAbsoluteTimeEnabled === 1 ? 0 : 1,
                                                }
                                            }));
                                        }}>
                                            <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.fixedAbsoluteTimeEnabled === 1} icons={false} className='custom-react-toggle' />
                                            <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>Fixed Timer</div>
                                        </div>
                                        <div className='textfield-container'>
                                            <Header name="in min" />
                                            <TextField
                                                onChange={(e) => {
                                                    let updatedValue = parseInt(e.target.value);
                                                    if (updatedValue <= 0) updatedValue = 1;
                                                    this.setState(prevState => ({
                                                        assignment: {
                                                            ...prevState.assignment,
                                                            test_time: updatedValue,
                                                        }
                                                    }));
                                                }} value={assignment?.test_time} type='number' size='small' sx={{ width: "60px" }} />
                                        </div>
                                    </div>
                                    : null}
                            </Box>
                            : null}
                    </div>


                    {/* 3rd row */}
                    <div className='row-containers'>
                        {this.props.isAssessment ? null :
                            <React.Fragment>
                            <div className='textfield-container'>
                                <Header name="Default Mastery" tooltip={this.helpTextModel.getHelpTextForKey('Default Mastery')} />
                                <TextField onChange={(e) => {
                                    let updatedValue = parseInt(e.target.value);
                                    if (updatedValue <= 0) updatedValue = 1;
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            mastery_condition: updatedValue,
                                        }
                                    }));
                                }} value={assignment?.mastery_condition} type='number' size='small' sx={{ width: "60px" }} />
                            </div>
                            <div className='textfield-container'>
                                <Header name="Max. Attempts" tooltip={this.helpTextModel.getHelpTextForKey('Max Attempts')} />
                                <TextField onChange={(e) => {
                                    let updatedValue = parseInt(e.target.value);
                                    if (updatedValue <= 0) updatedValue = 1;
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            maximum_attempted: updatedValue,
                                        }
                                    }));
                                }} value={assignment?.maximum_attempted} type='number' size='small' sx={{ width: "60px" }} />
                            </div>
                            <div className='textfield-container'>
                                <Header name="NOCQC" tooltip={this.helpTextModel.getHelpTextForKey('NOCQC')} />
                                <TextField onChange={(e) => {
                                    let updatedValue = parseInt(e.target.value);
                                    if (updatedValue <= 0) updatedValue = 1;
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            NoCQC: updatedValue,
                                        }
                                    }));
                                }} value={assignment?.NoCQC} type='number' size='small' sx={{ width: "60px" }} />
                            </div>
                            </React.Fragment>
                        }
                        {/* <div className='textfield-container'>
                            <Header name="Default Mastery" tooltip={this.helpTextModel.getHelpTextForKey('Default Mastery')} />
                            <TextField onChange={(e) => {
                                let updatedValue = parseInt(e.target.value);
                                if (updatedValue <= 0) updatedValue = 1;
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        mastery_condition: updatedValue,
                                    }
                                }));
                            }} value={assignment?.mastery_condition} type='number' size='small' sx={{ width: "60px" }} />
                        </div>
                        <div className='textfield-container'>
                            <Header name="Max. Attempts" tooltip={this.helpTextModel.getHelpTextForKey('Max Attempts')} />
                            <TextField onChange={(e) => {
                                let updatedValue = parseInt(e.target.value);
                                if (updatedValue <= 0) updatedValue = 1;
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        maximum_attempted: updatedValue,
                                    }
                                }));
                            }} value={assignment?.maximum_attempted} type='number' size='small' sx={{ width: "60px" }} />
                        </div>
                        <div className='textfield-container'>
                            <Header name="Default NOCQC" tooltip={this.helpTextModel.getHelpTextForKey('NOCQC')} />
                            <TextField onChange={(e) => {
                                let updatedValue = parseInt(e.target.value);
                                if (updatedValue <= 0) updatedValue = 1;
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        NoCQC: updatedValue,
                                    }
                                }));
                            }} value={assignment?.NoCQC} type='number' size='small' sx={{ width: "60px" }} />
                        </div>
                        <div className='textfield-container'>
                            <Header name="Lock Out" tooltip={this.helpTextModel.getHelpTextForKey('LockOut')} />
                            <TextField onChange={(e) => {
                                let updatedValue = parseInt(e.target.value);
                                if (updatedValue <= 0) updatedValue = 1;
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        lockoutN: updatedValue,
                                    }
                                }));
                            }} value={assignment?.lockoutN} type='number' size='small' sx={{ width: "60px" }} />
                        </div> */}
                        {this.props.isTutorial ? null :
                            <div className='textfield-container'>
                                <Header name="Lock Out" tooltip={this.helpTextModel.getHelpTextForKey('LockOut')} />
                                <TextField onChange={(e) => {
                                    let updatedValue = parseInt(e.target.value);
                                    if (updatedValue <= 0) updatedValue = 1;
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            lockoutN: updatedValue,
                                        }
                                    }));
                                }} value={assignment?.lockoutN} type='number' size='small' sx={{ width: "60px" }} />
                            </div>
                        }
                        {this.state.loadingSections ?
                            <BeatLoader color={'#bb0000'} loading={true} size={12} />
                            :
                           (this.props.isLibrary ? null : 
                                <React.Fragment>
                                {this.state.enableSubSection ?
                                    <div className='section-container'>
                                        <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>Sections & Subsections List</div>
                                        <SFSectionAndSubsectionSelectField
                                            sections={this.state.sections}
                                            subSections={this.state.subsections}
                                            value={this.getSubsectionSelectValue()}
                                            onChange={this.handleSubsectionSelectChange}
                                        />
                                    </div>
                                    :
                                    (!this.props.isTutorial ? 
                                    <div className='section-container'>
                                        <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>Section List</div>
                                        <FormControl fullWidth>
                                            <Select
                                                size='small'
                                                id="section-id"
                                                multiple
                                                value={this.state.selectedSectionIDArr}
                                                onChange={this.handleSectionSelect}
                                                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                                renderValue={(selected) => (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                        {selected.map((value) => {
                                                            let section = this.state.sections?.find(sec => sec.section_id === value);
                                                            return (
                                                                <Chip className='custom-chip' key={value} label={section?.section_name} />
                                                            )
                                                        })}
                                                    </Box>
                                                )}
                                            >
                                                {this.state.sections?.map((section, index) => {
                                                    return (
                                                        <MenuItem key={index} value={section.section_id}>
                                                            {section.section_name}
                                                        </MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                        : null)
                                }
                            </React.Fragment>)
                        }
                        {this.state.hasSubSections ?
                            <div className='textfield-container'>
                                <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>Enable Subsections</div>
                                <Toggle checked={this.state.enableSubSection} icons={false} className='custom-react-toggle'
                                    onChange={() => {
                                        this.setState({
                                            selectedSectionIDArr: [],
                                            selectedSectionAndSubsectionList: [],
                                            enableSubSection: !this.state.enableSubSection
                                        })
                                    }}
                                />
                            </div>
                            : null}

                        {!this.props.isTutorial ? 
                        <Box component="fieldset" className='row-containers'>
                            <legend>Anonymous</legend>
                            <div className='checkbox-container' onClick={() => {
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        is_anonymous: prevState.assignment?.is_anonymous ? false : true,
                                    }
                                }));
                            }}>
                                <Toggle disabled={this.props.isAssessment} onClick={(e) => e.stopPropagation()} checked={assignment?.is_anonymous} icons={false} className='custom-react-toggle' />
                                <Header name="Anonymous" tooltip={<div style={{ padding: "0 8px" }}>
                                    {this.helpTextModel.getHelpTextForKey("Anonymous")}
                                </div>} />
                            </div>
                            {assignment?.is_anonymous ?
                                <div>
                                    <Tooltip title={
                                        <Typography style={{ color: "#fff" }}>
                                            {!assignment?.quiz_id ?
                                                <div>Please create the assignment to copy the link</div>
                                                : <div>Copy Anonymous Link</div>}
                                        </Typography>
                                    }
                                        placement='top'
                                        arrow
                                    >
                                        <span>
                                            <Button 
                                                disabled={!assignment?.quiz_id}
                                                size='small'
                                                variant='contained'
                                                onClick={() => {
                                                    let link = assignment?.anonymous_link ?? "";
                                                    link = link.replace("asu.student.dev", "colorado.student.dev");
                                                    navigator.clipboard.writeText(link)
                                                    NotificationManager.success("Anonymous Link was copied to your clipboard.", "")
                                                }}
                                            >
                                                <IoLink fontSize={16} style={{marginRight:'4px'}}/> Copy Link 
                                            </Button>
                                        </span>
                                    </Tooltip>
                                </div>
                                : null}
                        </Box>
                        : null}
                    </div>

                    {/* Select subject topic and categories */}
                    {/* {this.props.isLibrary ? */}
                    <div style={{ marginTop: "2rem" }}>
                        <div style={{ display: "flex", gap: "6px", marginBottom: "1rem" }}>
                            <Typography fontSize={16} fontWeight={600}>Select Categories/Subcategories</Typography>
                            <Tooltip
                                title={<Typography className='text-white' fontSize={14}>
                                    {this.helpTextModel.getHelpTextForKey("Select Categories/SubCategories")}
                                </Typography>}
                                placement='top'
                                arrow
                            >
                                <span>
                                    <BsInfoCircleFill color='#737373' size={14}
                                        style={{
                                            flexShrink: 0,
                                            minWidth: "12px",
                                            minHeight: "12px",
                                            verticalAlign: "middle",
                                            cursor: "pointer",
                                        }} />
                                </span>
                            </Tooltip>
                        </div>
                        <SubjectTopicCategorySelect
                            onAddSubcategories={this.onAddSubcategories}
                        />
                    </div>
                    {/* : null} */}
                    {/* Choosen category/subcategory table */}
                    <div style={{ marginTop: "2rem", marginBottom: "1rem", display: "flex", gap: '1rem' }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", width: "100%" }}>
                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-end", gap: "1rem" }}>
                                <Typography fontSize={16} fontWeight={600}>Chosen Categories/Subcategories Table:</Typography>
                                <div className='button-flex'>
                                    <Button variant='contained' onClick={() => this.setState({
                                        showCategoryOptions: true,
                                    })}>
                                        Category Options
                                    </Button>
                                    <Tooltip
                                        title={<Typography className='text-white' fontSize={14}>
                                            {this.helpTextModel.getHelpTextForKey('Category Options')}
                                        </Typography>}
                                        placement='top'
                                        arrow
                                    >
                                        <span>
                                            <BsInfoCircleFill color='#737373' size={14}
                                                style={{
                                                    flexShrink: 0,
                                                    minWidth: "12px",
                                                    minHeight: "12px",
                                                    verticalAlign: "middle",
                                                    cursor: "pointer",
                                                }} />
                                        </span>
                                    </Tooltip>
                                </div>
                                {this.props.isLibrary || this.props.isTutorial ? null :
                                    <div className='button-flex'>
                                        <Button variant='contained' onClick={() => this.setState({
                                            showEditDueDates: true,
                                        })}>
                                            Edit Due Date and Locks
                                        </Button>
                                        <Tooltip
                                            title={<Typography className='text-white' fontSize={14}>
                                                {this.helpTextModel.getHelpTextForKey('Edit Due Dates')}
                                            </Typography>}
                                            placement='top'
                                            arrow
                                        >
                                            <span>
                                                <BsInfoCircleFill color='#737373' size={14}
                                                    style={{
                                                        flexShrink: 0,
                                                        minWidth: "12px",
                                                        minHeight: "12px",
                                                        verticalAlign: "middle",
                                                        cursor: "pointer",
                                                    }} />
                                            </span>
                                        </Tooltip>
                                    </div>
                                }
                            </div>
                            <div style={{ fontSize: '1rem', fontWeight: '600' }}>
                                {/* Mastery Units: <span>{assignment?.mastery_units}</span> */}
                                Mastery Units: <span>{this.state.categories ?  this.state.categories.length : 0}</span>
                            </div>
                        </div>
                    </div>
                    <div className='matrix-table-container main-catsubcat-table'>
                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <table className='matrix-table' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead className='matrix-table-head assignment-creation-subcat-table-thead' style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 10 }}>
                                    <tr className="matrix-row-header">
                                        <th className="matrix-row-cell" style={{ width: "50px" }}></th>
                                        <th className="matrix-row-cell" style={{  }}>No.</th>
                                        <th className="matrix-row-cell" style={{ minWidth: "150px" }}>Subjects</th>
                                        <th className="matrix-row-cell" style={{ minWidth: "150px" }}>Topics</th>
                                        <th className="matrix-row-cell" style={{ minWidth: "200px" }}>Categories</th>
                                        <th className="matrix-row-cell" style={{ minWidth: "200px" }}>Subcategories</th>
                                        <th
                                            key={0}
                                            className="matrix-row-cell"
                                            style={{
                                                minWidth: "140px",
                                            }}
                                        >
                                            <div className='category-header-tag cat-cell text-align-center' onClick={() => { }}>
                                                <Header name="Random question order" tooltip={this.helpTextModel.getHelpTextForKey('Random question order')} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "100px",
                                            }}
                                        >
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name="NOCQSC" tooltip={this.helpTextModel.getHelpTextForKey('Weights')} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "130px",
                                            }}>
                                            <div className='category-header-tag cat-cell text-align-center' onClick={() => { }}>
                                                <Header name="Available Questions" tooltip={this.helpTextModel.getHelpTextForKey('Available Subcategory Questions')} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "100px",
                                            }}>
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name="Graded" tooltip={this.helpTextModel.getHelpTextForKey('Graded')} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "120px",
                                            }}>
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name="Enable Analytics" tooltip={this.helpTextModel.getHelpTextForKey('Enable Analytics')} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "120px",
                                            }}>
                                            <div className='category-header-tag cat-cell text-align-center' onClick={() => { }}>
                                                <Header name="Enable Feedback" tooltip={this.helpTextModel.getHelpTextForKey('Enable Feedback')} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "100px",
                                            }}>
                                            <div className='category-header-tag cat-cell text-align-center' onClick={() => { }}>
                                                Display Order
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "80px",
                                            }}>
                                            <div className='category-header-tag cat-cell'>
                                                Actions
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <Droppable droppableId="subCategories">
                                    {(provided) => (
                                        <tbody
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                        >
                                            {this.state.subcategories?.map((subcat, index) => {
                                                //console.debug("subcat>>??", subcat)
                                                let subcategoryID = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}_${subcat.subcategory_id}`
                                                let nocqc = 1;
                                                if (subcat?.subcategory_weight) nocqc = subcat?.subcategory_weight;

                                                const l = this.state.subcategories.length;
                                                const currentCatKey = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;
                                                let isAtFirst = false;
                                                let isAtLast = false;

                                                let category = this.state.categories?.find(cat => {
                                                    let catKey = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
                                                    return catKey === currentCatKey;
                                                })

                                                if (category) {
                                                    isAtFirst = category.atFirst === 1;
                                                    isAtLast = category.atLast === 1;
                                                }

                                                const hideUpArrow = index === 0;
                                                const hideDownArrow = index === l - 1;

                                                let upBtnDisabled = isAtFirst || isAtLast;
                                                let downBtnDisabled = upBtnDisabled;

                                                // Check if its previous is a different category and it has atFirst
                                                if (index > 0) {
                                                    const prevSubcat = this.state.subcategories[index - 1];
                                                    let prevCat = this.state.categories?.find(c => {
                                                        let k = `${c.subject_id}_${c.topic_id}_${c.category_id}`;
                                                        return k === `${prevSubcat.subject_id}_${prevSubcat.topic_id}_${prevSubcat.category_id}`;
                                                    })
                                                    if (prevCat && prevCat.atFirst === 1) {
                                                        upBtnDisabled = true;
                                                    }
                                                }

                                                if (index < l - 1) {
                                                    const nextSubcat = this.state.subcategories[index + 1];
                                                    let nextCat = this.state.categories?.find(c => {
                                                        let k = `${c.subject_id}_${c.topic_id}_${c.category_id}`;
                                                        return k === `${nextSubcat.subject_id}_${nextSubcat.topic_id}_${nextSubcat.category_id}`;
                                                    })

                                                    if (nextCat && nextCat.atLast === 1) {
                                                        downBtnDisabled = true;
                                                    }
                                                }

                                                /* if (!hideUpArrow && index > 0) {
                                                    const prevSubcat = this.state.subcategories[index - 1];
                                                    const prevCatKey = `${prevSubcat.subject_id}_${prevSubcat.topic_id}_${prevSubcat.category_id}`;
    
                                                    if (currentCatKey === prevCatKey) {
                                                        upBtnDisabled = false;
                                                    }
                                                }
    
                                                // Check DOWN
                                                if (!hideDownArrow && index < l - 1) {
                                                    const nextSubcat = this.state.subcategories[index + 1];
                                                    const nextCatKey = `${nextSubcat.subject_id}_${nextSubcat.topic_id}_${nextSubcat.category_id}`;
    
                                                    if (currentCatKey === nextCatKey) {
                                                        downBtnDisabled = false;
                                                    }
                                                } */

                                                //console.debug("upBtnDisabled, downBtnDisabled", upBtnDisabled, downBtnDisabled)

                                                const atFirstTooltip = `Moving up is disabled\nbecause this category\nis checked either\nAt first or At last\nin category options`;
                                                const atLastTooltip = `Moving down is disabled\nbecause this category\nis checked either\nAt First or At last\nin category options`;

                                                let dragDisabled = upBtnDisabled || downBtnDisabled;
                                                const dragDisableMsg = "Dragging is disabled\nbecause this category\nis checked either\nAt first or At last\nin category option"

                                                return (
                                                    <Draggable
                                                        key={subcategoryID}
                                                        draggableId={subcategoryID}
                                                        index={index}
                                                        isDragDisabled={dragDisabled}
                                                    >
                                                        {(provided, snapshot) => (
                                                            <tr
                                                                className={`matrix-row ${subcat.invalid ? "invalid-subcat" : ""}`}
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                    width: "fit-content",
                                                                    backgroundColor: snapshot.isDragging ? "white" : "inherit",
                                                                    boxShadow: snapshot.isDragging
                                                                        ? "0 4px 12px rgba(0,0,0,0.15)"
                                                                        : "none",
                                                                    // cursor: "grab",
                                                                    transition: "background-color 0.2s ease",
                                                                    ...provided.draggableProps.style,
                                                                }}
                                                            >
                                                                <td className="matrix-row-cell drag-cell" style={{ minWidth: "50px" }}>
                                                                    <Tooltip
                                                                        disableHoverListener={!dragDisabled}
                                                                        title={<Typography className='text-white' fontSize={14}>
                                                                            {dragDisableMsg}</Typography>}>

                                                                        <MdDragIndicator fontSize={26}
                                                                            style={{
                                                                                cursor: dragDisabled ? "not-allowed" : "grab",
                                                                                color: dragDisabled ? "#a7a7a7" : "#333",
                                                                            }}
                                                                        />
                                                                    </Tooltip>
                                                                </td>
                                                                <td className="matrix-row-cell drag-cell" style={{ }}>
                                                                    {index + 1}
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ textAlign: 'left', minWidth: "150px" }}>
                                                                    <div className='category-name-cell'>
                                                                        <div className='category-name'>
                                                                            {subcat.subject_name}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ textAlign: 'left', minWidth: "150px" }}>
                                                                    <div className='category-name-cell'>
                                                                        <div className='category-name'>
                                                                            {subcat.topic_name}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ textAlign: 'left', minWidth: "200px" }}>
                                                                    <div className='category-name-cell'>
                                                                        <div className='category-name'>
                                                                            {subcat.category_Name || subcat.category_name}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ textAlign: 'left', minWidth: "200px" }}>
                                                                    <div className='category-name-cell'>
                                                                        <div className='category-name'>
                                                                            {subcat.subcategory_name}
                                                                            {/* ({subcat.order}) */}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "120px" }}>
                                                                    <Toggle checked={subcat?.randomize_questions === 1} icons={false}
                                                                        onChange={() => {
                                                                            let updatedValue = subcat?.randomize_questions === 1 ? 0 : 1;
                                                                            let updatedSubcategories = [...this.state.subcategories];
                                                                            updatedSubcategories[index].randomize_questions = updatedValue;
                                                                            this.setState({ subcategories: updatedSubcategories });
                                                                        }}
                                                                        className='custom-react-toggle' />
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "100px" }}>
                                                                    <div style={{ padding: "6px" }}>
                                                                        <TextField size='small'
                                                                            sx={{
                                                                                width: "50px",
                                                                            }}

                                                                            value={nocqc}
                                                                            type='number'
                                                                            onChange={(e) => {
                                                                                let updatedValue = parseInt(e.target.value);
                                                                                if (updatedValue <= 0) updatedValue = 1;
                                                                                let updatedSubcategories = [...this.state.subcategories];
                                                                                updatedSubcategories[index].subcategory_weight = updatedValue;
                                                                                this.setState({ subcategories: updatedSubcategories });
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "100px" }}>
                                                                    {subcat.question_count}
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "80px" }}>
                                                                    <Toggle checked={subcat.non_graded === 0} icons={false} className='custom-react-toggle'
                                                                        onChange={() => {
                                                                            let updatedValue = subcat?.non_graded === 1 ? 0 : 1;
                                                                            let updatedSubcategories = [...this.state.subcategories];
                                                                            updatedSubcategories[index].non_graded = updatedValue;
                                                                            this.setState({ subcategories: updatedSubcategories });
                                                                        }}
                                                                    />
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "100px" }}>
                                                                    <Toggle checked={subcat.enable_analytics} icons={false} className='custom-react-toggle'
                                                                        onChange={() => {
                                                                            let updatedValue = !subcat.enable_analytics;
                                                                            let updatedSubcategories = [...this.state.subcategories];
                                                                            updatedSubcategories[index].enable_analytics = updatedValue;
                                                                            this.setState({ subcategories: updatedSubcategories });
                                                                        }}
                                                                    />
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "100px" }}>
                                                                    <Toggle checked={subcat.enable_feedback} icons={false} className='custom-react-toggle'
                                                                        onChange={() => {
                                                                            let updatedValue = !subcat.enable_feedback;
                                                                            let updatedSubcategories = [...this.state.subcategories];
                                                                            updatedSubcategories[index].enable_feedback = updatedValue;
                                                                            this.setState({ subcategories: updatedSubcategories });
                                                                        }}
                                                                    />
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "100px" }}>
                                                                    <div className='display-order'>
                                                                        {hideUpArrow ? <div></div> :
                                                                            <Tooltip title={<Typography className='text-white' fontSize={14}>
                                                                                {atFirstTooltip}
                                                                            </Typography>} placement="top" arrow
                                                                                disableHoverListener={!upBtnDisabled}
                                                                            >
                                                                                <IconButton onClick={() => {
                                                                                    if (upBtnDisabled) return;
                                                                                    let updatedSubcategories = [...this.state.subcategories];

                                                                                    let currentSubcat = { ...updatedSubcategories[index] };
                                                                                    let prevSubcat = { ...updatedSubcategories[index - 1] };
                                                                                    let tempOrder = currentSubcat.order;

                                                                                    currentSubcat.order = prevSubcat.order;
                                                                                    prevSubcat.order = tempOrder;

                                                                                    updatedSubcategories[index] = prevSubcat;
                                                                                    updatedSubcategories[index - 1] = currentSubcat;

                                                                                    updatedSubcategories = this.markInvalidSubcategoryOrder(updatedSubcategories);

                                                                                    this.setState({ subcategories: updatedSubcategories });
                                                                                }}>
                                                                                    <PiCaretUpBold color={`${upBtnDisabled ? "#a7a7a7" : "#bb0000"}`} />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        }

                                                                        {hideDownArrow ? <div></div> :
                                                                            <Tooltip title={<Typography className='text-white' fontSize={14}>
                                                                                {atLastTooltip}
                                                                            </Typography>} placement="top" arrow
                                                                                disableHoverListener={!downBtnDisabled}
                                                                            >
                                                                                <IconButton onClick={() => {
                                                                                    if (downBtnDisabled) return;
                                                                                    let updatedSubcategories = [...this.state.subcategories];

                                                                                    let currentSubcat = { ...updatedSubcategories[index] };
                                                                                    let nextSubcat = { ...updatedSubcategories[index + 1] };
                                                                                    let tempOrder = currentSubcat.order;

                                                                                    currentSubcat.order = nextSubcat.order;
                                                                                    nextSubcat.order = tempOrder;

                                                                                    updatedSubcategories[index] = nextSubcat;
                                                                                    updatedSubcategories[index + 1] = currentSubcat;

                                                                                    updatedSubcategories = this.markInvalidSubcategoryOrder(updatedSubcategories);

                                                                                    this.setState({ subcategories: updatedSubcategories });
                                                                                }}>
                                                                                    <PiCaretDownBold color={`${downBtnDisabled ? "#a7a7a7" : "#bb0000"}`} />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "80px" }}>
                                                                    <IconButton onClick={() => {
                                                                        this.handleRemoveSubcategory(index)
                                                                    }}>
                                                                        <IoIosCloseCircle color='#bb0000' />
                                                                    </IconButton>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </Draggable>
                                                )
                                            })}
                                            {provided.placeholder}
                                        </tbody>
                                    )}
                                </Droppable>
                            </table>
                        </DragDropContext>
                    </div>


                    {/* Final row */}
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Typography fontSize={16} fontWeight={600} marginTop={0} marginBottom={1}>Splash Screen:</Typography>

                            <div className='w-100 splash-screen-container'>
                                <TextEditor className="custom-text-editor"
                                    value={this.state.splashTextEditorObj}
                                    onChange={this.onSplashScreenTextChange}
                                    placeholder="Enter splash screen text"
                                />
                                {this.state.altSplashScreenTextVisible ?
                                    <div style={{ marginTop: "1rem" }}>
                                        <p style={{ fontSize: "medium", color: '#bb0000' }}><label for="altsplashId">
                                            <span style={{ marginRight: "4px" }}>
                                                Title and Alternative Text for all Images in SplashScreen
                                            </span>
                                            <Tooltip
                                                title={<Typography className='text-white' fontSize={14}>
                                                      Alternate title and text for each image.
                                                </Typography>}
                                                placement='top'
                                                arrow
                                            >
                                                <span>
                                                    <BsInfoCircleFill color='#737373' size={14}
                                                        style={{
                                                            flexShrink: 0,
                                                            minWidth: "12px",
                                                            minHeight: "12px",
                                                            verticalAlign: "middle",
                                                            cursor: "pointer",
                                                        }} />
                                                </span>
                                            </Tooltip>
                                        </label></p>

                                        {this.state.splashScreenAltText.map((img, idx) => (
                                        <div key={idx} style={{ width:"50%",display: "flex", gap: "10px", marginBottom: "8px" }}>
                                            <TextField
                                            label={`Image ${idx + 1} Title`}
                                            value={img.title}
                                            fullWidth
                                            id="altendsplashId"
                                            onChange={e => {
                                                const images = [...this.state.splashScreenAltText];
                                                images[idx].title = e.target.value;
                                                 this.setState({ splashScreenAltText:images });
                                            }}
                                            />
                                            <TextField
                                            label={`Image ${idx + 1} Alt Text`}
                                            value={img.alt}
                                            fullWidth
                                            onChange={e => {
                                                const images = [...this.state.splashScreenAltText];
                                                images[idx].alt = e.target.value;
                                                this.setState({ splashScreenAltText:images });
                                            }}
                                            />
                                        </div>
                                        ))}

                                        {/* Hidden field for DB storage */}
                                        <input
                                        type="hidden"
                                        id="altsplashId"
                                        name="altSplashScreenEditor"
                                        value={this.state.splashScreenAltText.map(img => `${img.title};${img.alt}`).join(';')}
                                        />
                                    </div>
                                    : null}
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography fontSize={16} fontWeight={600} marginTop={0} marginBottom={1}>End Splash Screen:</Typography>

                            <div className='w-100 splash-screen-container'>
                                <TextEditor className="custom-text-editor"
                                    value={this.state.endSplashTextEditorObj}
                                    onChange={this.onEndSplashScreenTextChange}
                                    placeholder="Enter splash screen text"
                                />
                               {this.state.altSplashEndScreenTextVisible && (
                                    <div style={{ marginTop: "1rem" }}>
                                                                     <p style={{ fontSize: "medium", color: '#bb0000' }}><label for="altendsplashId">
                                            <span style={{ marginRight: "4px" }}>
                                               Title and Alternative Text for all Images in End SplashScreen
                                            </span>
                                            <Tooltip
                                                title={<Typography className='text-white' fontSize={14}>
                                                    Alternate title and text for each image.
                                                </Typography>}
                                                placement='top'
                                                arrow
                                            >
                                                <span>
                                                    <BsInfoCircleFill color='#737373' size={14}
                                                        style={{
                                                            flexShrink: 0,
                                                            minWidth: "12px",
                                                            minHeight: "12px",
                                                            verticalAlign: "middle",
                                                            cursor: "pointer",
                                                        }} />
                                                </span>
                                            </Tooltip>
                                        </label></p>

                                        {this.state.endSplashScreenAltText.map((img, idx) => (
                                        <div key={idx} style={{ width:"50%",display: "flex", gap: "10px", marginBottom: "8px" }}>
                                            <TextField
                                            label={`Image ${idx + 1} Title`}
                                            value={img.title}
                                            fullWidth
                                            id="altendsplashId"
                                            onChange={e => {
                                                const images = [...this.state.endSplashScreenAltText];
                                                images[idx].title = e.target.value;
                                                 this.setState({ endSplashScreenAltText:images });
                                            }}
                                            />
                                            <TextField
                                            label={`Image ${idx + 1} Alt Text`}
                                            value={img.alt}
                                            fullWidth
                                            onChange={e => {
                                                const images = [...this.state.endSplashScreenAltText];
                                                images[idx].alt = e.target.value;
                                                this.setState({ endSplashScreenAltText:images });
                                            }}
                                            />
                                        </div>
                                        ))}

                                        {/* Hidden field for DB storage */}
                                        <input
                                        type="hidden"
                                        id="altsplashId"
                                        name="altSplashScreenEditor"
                                        value={this.state.endSplashScreenAltText.map(img => `${img.title};${img.alt}`).join(';')}
                                        />
                                    </div>
                                    )}
                            </div>
                        </Grid>
                    </Grid>
                    </fieldset>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} className='footer-btn-container' style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "12px" }}>
                            {this.state.isCurrentSemester && assignment?.status === 0 ?
                                <Button disabled={this.state.saveLoading || this.state.savePublishLoading} variant='contained'
                                    onClick={() => {
                                        this.handleSaveClick(0)
                                    }}
                                    className='button-container'>
                                    <div style={{ opacity: this.state.saveLoading ? 0 : 1 }}>
                                        Save
                                    </div>
                                    <div className='abs-center'>
                                        {this.state.saveLoading && (
                                            <CircularProgress size={20} />
                                        )}
                                    </div>
                                </Button>
                                : null}
                            {/* {assignment?.status === 1 ? */}
                            {this.state.isCurrentSemester && (this.props.isLibrary === null || this.props.isLibrary === undefined) ? 
                            <Button variant='contained' disabled={this.state.savePublishLoading || this.state.saveLoading}
                                onClick={() => {
                                    this.handleSaveClick(1)
                                }}
                                className='button-container'
                            >
                                <div style={{ opacity: this.state.savePublishLoading ? 0 : 1 }}>
                                    Save & Publish
                                </div>
                                <div className='abs-center'>
                                    {this.state.savePublishLoading && (
                                        <CircularProgress size={20} />
                                    )}
                                </div>
                            </Button>
                            : null}
                            {/* : null} */}
                            {/* Offered only to a caller that passes a handler for it, which is
                                how the library matrix deletes an assignment - it has no course
                                to reach the course matrix's popover through. disableButtons
                                withholds it the same way it withholds Save. */}
                            {this.props.onDeleteAssignment && !this.props.disableButtons && !this.props.readOnly ?
                                <Button variant='outlined' color='error'
                                    disabled={this.state.saveLoading || this.state.savePublishLoading}
                                    startIcon={<GoTrash />}
                                    onClick={() => this.props.onDeleteAssignment(assignment)}>
                                    Delete
                                </Button>
                                : null}
                            <Button variant='outlined' disabled={this.state.saveLoading || this.state.savePublishLoading} onClick={this.props.handleClose}>Close</Button>
                            {/* {assignment?.status === 0 && !this.props.isLibrary ?
                                <Button variant='contained' disabled={this.state.saveLoading}
                                    onClick={() => {
                                        this.handleSaveClick(1)
                                    }}
                                >Save & Publish</Button>
                                : null} */}
                            {/* <Button variant='outlined' disabled={this.state.saveLoading} onClick={this.props.handleClose}>Close</Button> */}
                        </Grid>
                    </Grid>

                    {this.state.showCategoryOptions ?
                        <CategoryOptionsModal
                            showModal={this.state.showCategoryOptions}
                            handleClose={() => this.setState({ showCategoryOptions: false })}
                            assignment={assignment}
                            categoriesArr={this.state.categories}
                            onSaveCategoryOption={this.onSaveCategoryOption}
                            fcCount={this.state.freeChoiceCount}
                            isTutorial={this.props.isTutorial}
                        />
                        : null}


                    {/* Edit due date and locks  */}
                    {this.state.showEditDueDates ?
                        <EditDueDataDialog
                            showDialog={this.state.showEditDueDates}
                            handleClose={() => this.setState({ showEditDueDates: false })}
                            assignment={assignment}
                            sections={this.state.sections}
                            enableSubSection={this.state.enableSubSection}
                            selectedSectionIDArr={this.state.selectedSectionIDArr}
                        />
                        : null}


                    <UnsyncedCategoriesDialog
                        unsyncedCategories={this.state.unsyncedCategories}
                        onClose={() => this.setState({ unsyncedCategories: null })}
                        title={this.props.isTutorial ? "This tutorial cannot be saved yet" : "This assignment cannot be saved yet"}
                        description={this.props.isTutorial
                            ? "These question bank rows are missing on the other universities, and this tutorial is syncing. Sync them from the question bank first, then save again."
                            : "These question bank rows are missing on the other universities, and this assignment is on a library matrix that is syncing. Sync them from the question bank first, then save again."}
                        showMatrix={!this.props.isTutorial}
                    />

                </DialogContent >
            </Dialog >
        )
    };
}



const EditDueDataDialog = ({
    showDialog,
    assignment,
    selectedSectionIDArr,
    sections,
    handleClose,
    enableSubSection
}) => {
    return (
        <Dialog
            open={showDialog}
            fullScreen
        >
            <DialogTitle>
                <Typography fontSize={18} fontWeight={500}>
                    <b>{assignment?.quiz_name}</b> Configuration
                </Typography>
            </DialogTitle>
            <div style={{
                margin: "0rem 2rem",
                marginBottom: "12px",
            }}>
                Use this page to make changes to this Quiz that would affect an individual student or a section or a subsection
            </div>
            <IconButton
                aria-label="close"
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                })}
                onClick={handleClose}
            >
                <IoMdCloseCircleOutline fontSize={24} />
            </IconButton>
            <EditWindow
                quizID={assignment.quiz_id}
                sectionList={
                    selectedSectionIDArr ?
                        selectedSectionIDArr.map(id => {
                            let section = sections.find(sec => sec.section_id === id)
                            if (section) {
                                return {
                                    label: section.section_name,
                                    id: section.section_id,
                                    value: true
                                }
                            }
                        })
                        : []
                }
                courseID={assignment.course_id}
                sectionID={assignment.section_id}
                isEnableSubsection={enableSubSection}
                selectedSectionAndSubsection={[]}
            />
        </Dialog>
    )
}

const Header = ({ name, tooltip }) => {
    return (

        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            gap: "6px",
        }} >
            <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>{name}</div>
            {tooltip ? 
                <Tooltip
                    title={<Typography className='text-white' fontSize={14}>
                        {tooltip}
                    </Typography>}
                    placement='top'
                    arrow
                >
                    <span>
                        <BsInfoCircleFill color='#737373' size={14}
                            style={{
                                flexShrink: 0,
                                minWidth: "12px",
                                minHeight: "12px",
                                verticalAlign: "middle",
                                cursor: "pointer",
                            }} />
                    </span>
                </Tooltip>
            : null}
        </div>
    )
}


export default AssignmentDetailModal;


